/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from "react";
import { Form, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import GroupWorksopTrainerList from "../../pages/GroupWorksopTrainerList";
import ViewMembersList from "../../pages/ViewMembersList";
import ConfirmModal from "../modal/ConfirmModal";
import SimplePopup from "../modal/SimplePopup";
import { getMembers, getTrainers, postWorkshopTimezone } from "../../redux/groupWorkshop/actions";
import { dateTimeStamp, randomGenerator, SessionKeys } from "../../utils/AppUtils";
import _, { set } from "lodash";
import GroupPreviewWorkshop from "../../pages/GroupPreviewWorkshop";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import { ErrorMessage, Field, FieldArray, Formik, Form as FormikForm } from "formik";
import moment from "moment";
import { Col, OverlayTrigger, Tooltip, Form as form } from "react-bootstrap";
import DatePickerWithIcon from "../../pages/DatePickerWithIcon";
import RichTextEditor from "../../pages/RichTextEditor";
import { getFileUploadOnAWS } from "../../redux/events/actions";
import SessionCardForm from "./SessionCardForm";
import { useTranslation } from "react-i18next";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TextField } from "@mui/material";
import { getLanguages } from "../../redux/user/actions";
import KickoffSessionCardForm from "./KickoffSessionCardForm";

const GroupWorkshopForm = (props) => {

  const {
    pageLine,
    workshopData,
    handleSubmitForm,
    confirmModal, setConfirmModal,
    showModalMsg,
    setIsLoading,
    error, setError,
    showLimitPopup, setShowLimitPopup,
    setIsDraft,
    btnName, sessionId, sessionOnlyUpdate,
    setSessionOnlyUpdate, setSessionId,
    saveBtn
  } = props

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formikRef = useRef(null);
  const { t } = useTranslation();
  // const postDataRef = useRef({});

  const httpUrlSchema = Yup.string()
    .url(t("urlInvalid"))

  const sessionObjectValidationSchema = Yup.object().shape({
    sessionId: Yup.string().optional(),
    sessionName: Yup.string()
      // .matches(
      //   /^[A-Za-z0-9\s]+$/,
      //   t("validationAlphabetsNumbersSpaces")
      // )
      .required(t("sessionNameRequired")),
    sessionStartDate: Yup.string().required(t("startDateRequired")),
    sessionEndDate: Yup.string()
      .test(
        "is-greater",
        t("endDateGreater"),
        function (value) {
          const { sessionStartDate } = this.parent;
          return moment(sessionStartDate).isSameOrBefore(value);
        }
      )
      .required(t("endDateRequired")),
    sessionStartTime: Yup.string()
      .test(
        "min-time",
        t("startTimePassed"),
        function (value) {
          const { sessionStartDate } = this.parent;
          const currentDate = moment()
          let sessionStartDateM = moment(sessionStartDate).format('DD/MM/YYYY')
          // console.log('sessionstartdate', moment(`${sessionStartDateM} ${value}`, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY HH:mm')) 
          if (currentDate.isSame(sessionStartDate, "day")) {
            // console.log('sessionstartdate', currentDate.format('DD/MM/YYYY HH:mm'))
            // console.log('sessionstartdate', moment(`${sessionStartDateM} ${value}`, 'DD/MM/YYYY HH:mm').isSameOrBefore(currentDate))
            if (moment(`${sessionStartDateM} ${value}`, 'DD/MM/YYYY HH:mm').isSameOrBefore(currentDate)) {
              // console.log('sessionstartdate validation failed')
              return false
            }
          }
          return true
        }
      )
      .required(t("startTimeRequired")),
    sessionEndTime: Yup.string()
      .test(
        'compare-start-time',
        t("endTimeAfterStart"),
        function (value) {
          const { sessionStartTime, sessionStartDate, sessionEndDate } = this.parent;
          const startDateM = moment(sessionStartDate).format('DD/MM/YYYY');
          const endDateM = moment(sessionEndDate).format('DD/MM/YYYY');
          const startDate = moment(`${startDateM} ${sessionStartTime}`, 'DD/MM/YYYY HH:mm');
          const endDate = moment(`${endDateM} ${value}`, 'DD/MM/YYYY HH:mm');
          if (endDate.isSameOrBefore(startDate)) {
            return false
          }
          return true
        }
      )
      .required(t("endTimeRequired")),
    sessionTimezone: Yup.string().required(t("timezoneRequired")),
    sessionLanguage: Yup.string().required(t("languageRequired")),
    sessionURL: Yup.string().when("modeOfAttendance", {
      is: "online", 
      then: httpUrlSchema.required(t("urlRequired")),
    }),
    sessionAddress: Yup.string().when("modeOfAttendance", {
      is: "onsite",
      then: Yup.string().required(t("addressRequired")),      
    }),
  })

  const kickoffSessionObjectValidationSchema = Yup.object().shape({
    sessionStartDate: Yup.string().when([], {
      is: () => isChecked,
      then: Yup.string().required(t("startDateRequired")),
    }),
    sessionEndDate: Yup.string().when([], {
      is: () => isChecked,
      then: Yup.string()
        .test(
          "is-greater",
          t("endDateGreater"),
          function (value) {
            const { sessionStartDate } = this.parent;
            return moment(sessionStartDate).isSameOrBefore(value);
          }
        ).required(t("endDateRequired")),
    }),
    sessionStartTime: Yup.string().when([], {
      is: () => isChecked,
      then: Yup.string()
        .test(
          "min-time",
          t("startTimePassed"),
          function (value) {
            const { sessionStartDate } = this.parent;
            const currentDate = moment()
            let sessionStartDateM = moment(sessionStartDate).format('DD/MM/YYYY')
            // console.log('sessionstartdate', moment(`${sessionStartDateM} ${value}`, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY HH:mm')) 
            if (currentDate.isSame(sessionStartDate, "day")) {
              // console.log('sessionstartdate', currentDate.format('DD/MM/YYYY HH:mm'))
              // console.log('sessionstartdate', moment(`${sessionStartDateM} ${value}`, 'DD/MM/YYYY HH:mm').isSameOrBefore(currentDate))
              if (moment(`${sessionStartDateM} ${value}`, 'DD/MM/YYYY HH:mm').isSameOrBefore(currentDate)) {
                return false
              }
            }
            return true
          }
        ).required(t("startTimeRequired")),
    }),
    sessionEndTime: Yup.string().when([], {
      is: () => isChecked,
      then: Yup.string()
        .test(
          'compare-start-time',
          t("endTimeAfterStart"),
          function (value) {
            const { sessionStartTime, sessionStartDate, sessionEndDate } = this.parent;
            const startDateM = moment(sessionStartDate).format('DD/MM/YYYY');
            const endDateM = moment(sessionEndDate).format('DD/MM/YYYY');
            const startDate = moment(`${startDateM} ${sessionStartTime}`, 'DD/MM/YYYY HH:mm');
            const endDate = moment(`${endDateM} ${value}`, 'DD/MM/YYYY HH:mm');
            if (endDate.isSameOrBefore(startDate)) {
              return false
            }
            return true
          }
        ).required(t("endTimeRequired")),
    }),
    sessionURL: Yup.string().when(["modeOfAttendance"], {
      is: (modeOfAttendance) => modeOfAttendance == "online" && isChecked, 
      then: httpUrlSchema.required(t("urlRequired")),
    }),
    sessionAddress: Yup.string().when(["modeOfAttendance"], {
      is: (modeOfAttendance) => modeOfAttendance == "onsite" && isChecked, 
      then: Yup.string().required(t("addressRequired")),      
    }),
    sessionTimezone: Yup.string().when([], {
      is: () => isChecked,
      then: Yup.string().required(t("timezoneRequired")),
    }),
    sessionLanguage: Yup.string().when([], {
      is: () => isChecked,
      then: Yup.string().required(t("timezoneRequired")),
    }),
  })

  const validationSchema = Yup.object().shape({
    sessionArray: Yup.array().of(sessionObjectValidationSchema),
    kickOffSession: kickoffSessionObjectValidationSchema,
    workshopName: Yup.string()
      // .matches(
      //   /^[A-Za-z0-9\s]+$/,
      //   t("workshopNamePattern")
      // )
      .required(t("workshopNameRequired")),
    trainerIds: Yup.array().of(
      Yup.string()
    ).required(t("trainerIdsRequired")),
    // language: Yup.string().required(t("languageRequired")), // Validation message
    dayOfMonth: Yup.number().when(["frequency", "nestedMonthly"], {
      is: (frequency, nestedMonthly) =>
        frequency === "monthly" && nestedMonthly === "1",
      then: Yup.number()
        .required(t("dayOfMonthRequired"))
        .min(1, t("dayRange"))
        .max(31, t("dayRange")),
    }),
    recurOn: Yup.array()
      .when(["frequency", "sessionType"], {
        is: (frequency, sessionType) =>
          frequency === "daily" && sessionType === "recurring",
        then: Yup.array().min(1, t("recurOnRequired")),
      }),
    description: Yup.string()
      .required("Description is required"),
    // .max(2000, "Description cannot exceed 2000 characters"),

    firstSecondThird: Yup.string().when(["frequency", "nestedMonthly"], {
      is: (frequency, nestedMonthly) =>
        frequency === "monthly" && nestedMonthly === "2",
      then: Yup.string().required(t("weekOptionRequired")),
    }),
    dayWeekdayWeekend: Yup.string().when(["frequency", "nestedMonthly"], {
      is: (frequency, nestedMonthly) =>
        frequency === "monthly" && nestedMonthly === "2",
      then: Yup.string().required(t("weekdayRequired")),
    }),

    monthName: Yup.number().when(["frequency", "nestedMonthly"], {
      is: (frequency, nestedMonthly) =>
        frequency === "monthly" && nestedMonthly === "2",
      then: Yup.number().required(t("monthNumberRequired")),
    }),
    urls: Yup.array()
      .of(httpUrlSchema.optional())
      .optional(),

    // timezone: Yup.string().required(t("timezoneRequired")),
  });

  const groupMembersList = useSelector((state) => state.groupworkshop.groupMembersList);
  const groupTrainersList = useSelector((state) => state.groupworkshop.groupTrainersList);
  const groupWorkshopTimezone = useSelector((state) => state.groupworkshop.groupWorkshopTimezone);
  const languageListRes = useSelector((state) => state.user.getLanguagesList);
  var fileRes = useSelector((state) => state.events.fileUploadAWSData);

  const [isChecked, setIsChecked] = useState(false);
  const [trainerValidation, setTrainerValidation] = useState("");
  const [memberValidation, setMemberValidation] = useState("");
  const [selectedTrainerId, setSelectedTrainerId] = useState([]);
  const [selectedParticipantId, setSelectedParticipantId] = useState([]);
  const [participantChips, setParticipantChips] = useState([]);
  const [chips, setChips] = useState([]);
  const [initialValues, setInitialValues] = useState({
    workshopName: "",
    description: "",
    thumbnail: "",
    banner: "",
    trainerIds: [],
    participantIds: [],
    urls: [""],
    frequency: "daily", // Default selected radio button
    nestedDaily: "everyday", // Default selected option for nested daily
    rangeofoccurence: "",
    recurOn: [], // nested weekly
    nestedMonthly: "1", // Default selected option for nested monthly-for 2 radio buttons
    dayOfMonth: "", // nested monthly
    firstSecondThird: "", //nested monthly
    dayWeekdayWeekend: "", //nested monthly
    monthName: "", //nested monthly
    status: "active",
    sessionType: "single",
    addDays: 1, //initially 1
    cards: [1],
    isDraft: false,
    deliveryMode: "virtual_broadcast",
    sessionArray: [{
      sessionId: "", //randomGenerator(5), // random 5 character string
      segmentId: "",
      // sessionName: "",
      sessionStartDate: "",
      sessionEndDate: "",
      sessionStartTime: "",
      sessionEndTime: "",
      modeOfAttendance: "online",
      sessionAddress: "",
      sessionURL: "",      
      sessionStartDateTime: "",
      sessionEndDateTime: "",
      sessionSegmentIds: "",
      sessionTimezone: "",
      sessionLanguage: "",
      isKickoffSession: false
    }],
    kickOffSession: {
      sessionId: "", //randomGenerator(5), // random 5 character string
      segmentId: "",
      sessionName: "",
      sessionStartDate: "",
      sessionEndDate: "",
      sessionStartTime: "",
      sessionEndTime: "",
      modeOfAttendance: "online",
      sessionAddress: "",
      sessionURL: "",
      sessionStartDateTime: "",
      sessionEndDateTime: "",
      sessionSegmentIds: "",
      sessionTimezone: "",
      sessionLanguage: "",
      isKickoffSession: true
    },
    // timezone: "",
    // addParticipants: "",
    // language: "",
    // kickoffSession_id: "",
    // kickoffSegment_id: "",
    // kickoffStartDate: "",
    // kickoffEndDate: "",
    // kickoffStartTime: "",
    // kickoffEndTime: "",
    // kickoffURL: "",
  });
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [errorMsgSession, setErrorMsgSession] = useState("");
  const [errorMsgPreqURL, setErrorMsgPreqURL] = useState("");
  const [hasSeries, setHasSeries] = useState(false);
  const [isMinuteSelected, setIsMinuteSelected] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [inputWorkshopValue, setWorkshopInputValue] = useState("");
  const [trainersList, setTrainersList] = useState([]);
  const [membersList, setMembersList] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showSuggestionsParticipants, setShowSuggestionsParticipants] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [inputValueParticipant, setInputValueParticipant] = useState("");
  const [filteredSuggestionsParticipant, setFilteredSuggestionsParticipant] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [trainersModal, setTrainersModal] = useState(false);
  const [membersModal, setMembersModal] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState("");
  const [sessionURL, setSessionURL] = useState("");
  const [status, setStatus] = useState("");
  const [workshopName, setWorkshopName] = useState("");
  const [sessionDate, setSessionDate] = useState("");
  const [sessionTime, setSessionTime] = useState("");
  const [description, setDescription] = useState("");
  const [latestSessionStartTime, setLatestSessionStartTime] = useState("");
  const [addDayError, setAddDayError] = useState(false);
  const [sessionValidation, setsessionValidation] = useState("");
  const [kickoffTimeValidation, setKickoffTimeValidation] = useState(false);
  const [kickoffLatestStartTime, setKickoffLatestStartTime] = useState("");
  const [kickoffLatestEndTime, setKickoffLatestEndTime] = useState("");
  const [timezoneList, setTimezoneList] = useState([]);
  const [isTimezoneListLoading, setIsTimezoneListLoading] = useState(false)
  const [languageList, setLanguagesList] = useState([])
  const [isLanguageListLoading, setIsLanguageListLoading] = useState(false)
  const [file, setFile] = useState("");
  const [fileData, setFileData] = useState([]);
  const [thumbnail, setThumbnail] = useState("");
  const [banner, setBanner] = useState("");
  const [sectionType, setSectionType] = useState("");
  const [prerequisites, setPrerequisites] = useState([]);
  const [resource, setResource] = useState([]);
  const [apiCalled, setApiCalled] = useState(false);
  const [isPreqLoading, setIsPreqLoading] = useState(false);
  const [isResourceLoading, setIsResourceLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [addDaysCount, setAddDaysCount] = useState("1");

  // Handle before unload event
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    e.returnValue = ''; // For modern browsers
    return ''; // For legacy browsers (e.g., Chrome, Firefox)
  };

  // Detect form dirty state and handle unsaved changes warning
  useEffect(() => {
    if (isFormDirty) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    getAllTrainerListing()
    getMembersListing()
    postWorkshopTimezoneListing()
    getLanguageListing()
  }, [dispatch]);

  useEffect(() => {
    if (errorMsgSession || errorMsgPreqURL) {
      setTimeout(() => {
        setErrorMsgSession("")
        setErrorMsgPreqURL("")
      }, 5000);
    }
  }, [errorMsgSession, errorMsgPreqURL])

  useEffect(() => {
    if (!_.isEmpty(workshopData)) {
      let kickOffSessionIndex = 0;
      let sessionType = 'single'
      let sessionArray = []
      let kickoffSessionData = {
        sessionId: initialValues.kickOffSession.sessionId, //randomGenerator(5), // random 5 character string
        segmentId: initialValues.kickOffSession.segmentId,
        sessionName: initialValues.kickOffSession.sessionName,
        sessionStartDate: initialValues.kickOffSession.sessionStartDate,
        sessionEndDate: initialValues.kickOffSession.sessionEndDate,
        sessionStartTime: initialValues.kickOffSession.sessionStartTime,
        sessionEndTime: initialValues.kickOffSession.sessionEndTime,
        modeOfAttendance: initialValues.kickOffSession.modeOfAttendance,
        sessionAddress: initialValues.kickOffSession.sessionAddress,
        sessionURL: initialValues.kickOffSession.sessionURL,
        sessionStartDateTime: initialValues.kickOffSession.sessionStartDateTime,
        sessionEndDateTime: initialValues.kickOffSession.sessionEndDateTime,
        sessionSegmentIds: initialValues.kickOffSession.sessionSegmentIds,
        sessionTimezone: initialValues.kickOffSession.sessionTimezone,
        sessionLanguage: initialValues.kickOffSession.sessionLanguage,
        isKickoffSession: true
      }
      let isRecurring = workshopData.recurring_on === '1'
      let preqURLs = []
      let trainerIds = []
      let participantIds = []
      // let timezone = workshopData.timezone.split("#")[1]

      if (workshopData.recurring_type && !sessionOnlyUpdate) {
        sessionType = 'recurring'
      }
      setHasSeries(workshopData.session_count > 1)

      if (sessionOnlyUpdate) {
        if (!_.isEmpty(workshopData.sessions_list)) {
          for (let session of workshopData.sessions_list) {
            if (session.session_id == sessionId) {
              trainerIds = !_.isEmpty(session.trainers) ? _.map(session.trainers, 'user_id') : []
              if (!_.isEmpty(trainerIds)) {
                trainerIds = !_.isEmpty(session.trainers) ? _.map(session.trainers, 'trainer_id') : []
              }
              participantIds = !_.isEmpty(session.participants) ? _.map(session.participants, 'user_id') : []
              let timezone = session.timezoneoffset ? session.timezoneoffset : "Europe/London"
              sessionArray.push({
                sessionId: session.session_id,
                segmentId: session.segment_id,
                sessionName: session.session_title,
                sessionStartDate: session.start_date,
                sessionEndDate: session.end_date,
                sessionStartTime: session.start_time ? moment.utc(session.start_time, 'HH:mm').tz(timezone).format('HH:mm:ss') : "",
                sessionEndTime: session.end_time ? moment.utc(session.end_time, 'HH:mm').tz(timezone).format('HH:mm:ss') : "",
                sessionURL: session.meeting_url,
                sessionStartDateTime: `${session.start_date} ${session.start_time}`,
                sessionEndDateTime: `${session.end_date} ${session.end_time}`,
                sessionTimezone: session.timezone ? session.timezone : "",
                sessionLanguage: session.language_id ? session.language_id : "",
                isKickoffSession: session.kickoff_session === "1",
                modeOfAttendance: session.session_mode,
                sessionAddress: session.session_location,
              })
            }
          }
          // setHasSeries(workshopData.sessions_list.length > 1)
        }
      } else {
        trainerIds = !_.isEmpty(workshopData?.trainers) ? _.map(workshopData?.trainers, 'user_id') : []
        participantIds = !_.isEmpty(workshopData?.participants) ? _.map(workshopData?.participants, 'user_id') : []
        // alert(JSON.stringify(participantIds))
        if (!_.isEmpty(workshopData.sessions_list)) {
          for (let [index, session] of workshopData.sessions_list.entries()) {
            if (session.kickoff_session === "1") {
              kickOffSessionIndex = index;
              let timezone = session.timezoneoffset ? session.timezoneoffset : "Europe/London"
              // session.start_time = moment.utc(session.start_time, 'HH:mm').tz(timezone).format('HH:mm')
              // session.end_time = moment.utc(session.end_time, 'HH:mm').tz(timezone).format('HH:mm')
              // session.timezone = session.timezone ? session.timezone : ""
              // session.language = session.language ? session.language : ""
              kickoffSessionData = {
                sessionId: session.session_id,
                segmentId: session.segment_id,
                sessionName: session.session_title,
                sessionStartDate: session.start_date,
                sessionEndDate: session.end_date,
                sessionStartTime: session.start_time ? moment.utc(session.start_time, 'HH:mm').tz(timezone).format('HH:mm:ss') : "",
                sessionEndTime: session.end_time ? moment.utc(session.end_time, 'HH:mm').tz(timezone).format('HH:mm:ss') : "",
                modeOfAttendance: session.session_mode,
                sessionAddress: session.session_location,
                sessionURL: session.meeting_url,                
                sessionStartDateTime: `${session.start_date} ${session.start_time}`,
                sessionEndDateTime: `${session.end_date} ${session.end_time}`,
                sessionTimezone: session.timezone ? session.timezone : "",
                sessionLanguage: session.language_id ? session.language_id : "",
                isKickoffSession: true,
              }
              setIsChecked(true)
              // kickoffSession = true
              // kickoffSessionData = session
              break
            }
          }
        }
        if (!_.isEmpty(workshopData.sessions_list) && !isRecurring) {
          for (let session of workshopData.sessions_list) {
            if (session.kickoff_session !== "1") {
              let timezone = session.timezoneoffset ? session.timezoneoffset : "Europe/London"
              sessionArray.push({
                sessionId: session.session_id,
                segmentId: session.segment_id,
                sessionName: session.session_title,
                sessionStartDate: session.start_date,
                sessionEndDate: session.end_date,
                sessionStartTime: session.start_time ? moment.utc(session.start_time, 'HH:mm').tz(timezone).format('HH:mm:ss') : "",
                sessionEndTime: session.end_time ? moment.utc(session.end_time, 'HH:mm').tz(timezone).format('HH:mm:ss') : "",
                modeOfAttendance: session.session_mode,
                sessionAddress: session.session_location,
                sessionURL: session.meeting_url,                
                sessionStartDateTime: `${session.start_date} ${session.start_time}`,
                sessionEndDateTime: `${session.end_date} ${session.end_time}`,
                sessionTimezone: session.timezone ? session.timezone : "",
                sessionLanguage: session.language_id ? session.language_id : "",
                isKickoffSession: false,
              })
            }
          }
        } else if (isRecurring && !_.isEmpty(workshopData.sessions_list)) {
          // setHasSeries(workshopData.sessions_list.length > 1)
          let timezone = workshopData.sessions_list[kickOffSessionIndex + 1].timezoneoffset ? workshopData.sessions_list[kickOffSessionIndex + 1].timezoneoffset : "Europe/London"
          sessionArray.push({
            sessionId: "",
            segmentId: "",
            sessionName: workshopData.sessions_list[kickOffSessionIndex + 1].session_title,
            sessionStartDate: workshopData.start_date,
            sessionStartTime: moment.utc(workshopData.start_time, 'HH:mm').tz(timezone).format('HH:mm'),
            sessionEndDate: workshopData.end_date,
            sessionEndTime: moment.utc(workshopData.end_time, 'HH:mm').tz(timezone).format('HH:mm'),
            modeOfAttendance: workshopData.sessions_list[kickOffSessionIndex + 1].session_mode,
            sessionAddress: workshopData.sessions_list[kickOffSessionIndex + 1].session_location,
            sessionURL: workshopData.sessions_list[kickOffSessionIndex + 1].meeting_url,
            sessionStartDateTime: `${workshopData.start_date} ${workshopData.start_time}`,
            sessionEndDateTime: `${workshopData.end_date} ${workshopData.end_time}`,
            sessionTimezone: workshopData.sessions_list[kickOffSessionIndex + 1].timezone ? workshopData.sessions_list[kickOffSessionIndex + 1].timezone : "",
            sessionLanguage: workshopData.sessions_list[kickOffSessionIndex + 1].language_id ? workshopData.sessions_list[kickOffSessionIndex + 1].language_id : "",
            isKickoffSession: false,
          })
        }
      }

      if (_.isArray(workshopData.resources) && !_.isEmpty(workshopData.resources)) {
        setResource(_.map(workshopData.resources, (resource) => {
          return {
            name: resource.file_name,
            type: resource.type,
            url: resource.url,
            dateModified: resource.dateModified || "",
            size: resource.size || 0,
          }
        }))
      }

      if (_.isArray(workshopData.prerequisites) && !_.isEmpty(workshopData.prerequisites)) {
        let preqArr = []
        for (let prerequisite of workshopData.prerequisites) {
          if (prerequisite.type !== "url") {
            preqArr.push({
              name: prerequisite.file_name,
              type: prerequisite.type,
              url: prerequisite.url,
              dateModified: prerequisite.dateModified || "",
              size: prerequisite.size || 0,
            })
          } else {
            preqURLs.push(prerequisite.url)
          }
        }
        // alert(JSON.stringify(preqArr))
        setPrerequisites(preqArr)
      }

      console.log('KICKOFF', kickoffSessionData)
      setInitialValues({
        workshopName: workshopData?.title,
        description: workshopData?.description,
        thumbnail: workshopData.thumbnail,
        banner: workshopData.banner,
        trainerIds: _.uniq(trainerIds),
        participantIds: _.uniq(participantIds),
        urls: preqURLs.length ? preqURLs : [""],
        language: workshopData.language_id,

        // kickoffSession_id: kickoffSessionArr.length ? kickoffSessionArr[0]?.session_id : "",
        // kickoffSegment_id: kickoffSessionArr.length ? kickoffSessionArr[0]?.segment_id : "",
        // kickoffStartDate: kickoffSession ? kickoffSessionData?.start_date : "",
        // kickoffEndDate: kickoffSession ? kickoffSessionData?.end_date : "",
        // kickoffStartTime: kickoffSession ? moment(kickoffSessionData?.start_time, 'HH:mm').format('HH:mm') : "",
        // kickoffEndTime: kickoffSession ? moment(kickoffSessionData?.end_time, 'HH:mm').format('HH:mm') : "",
        // kickoffURL: kickoffSession ? kickoffSessionData?.meeting_url : "",
        // kickoffTimezone: kickoffTimezone ? kickoffTimezone : "Europe/London",

        frequency: workshopData.recurring_type ? workshopData.recurring_type : "weekly", // Default selected radio button
        nestedDaily: workshopData.recurring_value ? workshopData.recurring_value : "everyday", // Default selected option for nested daily

        rangeofoccurence: workshopData.noofoccurances ? workshopData.noofoccurances : "",
        recurOn: _.isArray(workshopData?.recurring_value) ? workshopData?.recurring_value : [], // nested weekly

        nestedMonthly: workshopData.monthly_option || "1", // Default selected option for nested monthly-for 2 radio buttons
        dayOfMonth: workshopData.monthly_value ? workshopData.monthly_value : "",
        firstSecondThird: workshopData.monthly_option_number ? workshopData.monthly_option_number : "",
        dayWeekdayWeekend: workshopData.monthly_option_week ? workshopData.monthly_option_week : "",
        monthName: workshopData.month_number ? workshopData.month_number : "",

        status: workshopData?.status || "active",

        sessionType: sessionType,
        addDays: 1, //initially 1
        cards: !_.isEmpty(sessionArray) ? _.map(sessionArray, (s, i) => i + 1) : [1],
        timezone: workshopData.timezone,
        deliveryMode: "virtual_broadcast",
        sessionArray: sessionArray,
        kickOffSession: kickoffSessionData,
        isDraft: workshopData.is_draft === true,
      })
      setThumbnail(workshopData.thumbnail)
      setBanner(workshopData.banner)
    }
  }, [workshopData, sessionOnlyUpdate])

  useEffect(() => {
    if (!_.isEmpty(selectedTrainerId)) {
      formikRef.current.setFieldValue("trainerIds", selectedTrainerId)
      setTrainerValidation("");
    }
    if (!_.isEmpty(selectedParticipantId)) {
      formikRef.current.setFieldValue("participantIds", selectedParticipantId)
      setMemberValidation("");
    }
  }, [selectedTrainerId, selectedParticipantId]);

  useEffect(() => {
    if (kickoffLatestStartTime && latestSessionStartTime) {
      if (kickoffLatestStartTime < latestSessionStartTime) {
        setKickoffTimeValidation(false);
      }
    }

    if (kickoffLatestEndTime && latestSessionStartTime) {
      if (kickoffLatestEndTime < latestSessionStartTime) {
        setKickoffTimeValidation(false);
      }
    }
  }, [kickoffLatestStartTime, kickoffLatestEndTime, latestSessionStartTime]);

  useEffect(() => {
    if (!_.isEmpty(groupMembersList)) {
      const membersListing = groupMembersList;
      if (membersListing?.status === "success") {
        setMembersList(membersListing?.payload?.payload);
      } else {
        setMembersList([]);
      }
    }
  }, [groupMembersList])

  useEffect(() => {
    if (!_.isEmpty(groupTrainersList)) {
      const trainersListing = groupTrainersList;
      if (trainersListing?.status === "success") {
        setTrainersList(trainersListing?.payload?.payload);
      } else {
        setTrainersList([]);
      }
    }
  }, [groupTrainersList])

  useEffect(() => {
    if (!_.isEmpty(groupWorkshopTimezone)) {
      const timezoneListing = groupWorkshopTimezone;
      if (timezoneListing?.status === "success") {
        let listTz = timezoneListing?.payload?.payload
        setTimezoneList(_.sortBy(_.map(listTz, tz => ({
          value: `${tz.offset}#${tz.abbreviations}`,
          label: `${tz.abbreviations} (${tz.offset})`
        }))), 'label');
      } else {
        setTimezoneList([]);
      }
      setIsTimezoneListLoading(false)
    }
  }, [groupWorkshopTimezone])

  useEffect(() => {
    console.log("languages-", languageListRes);
    if (!_.isEmpty(languageListRes)) {
      if (languageListRes?.status === "success") {
        // setLanguageSet(languageListRes?.payload?.payload);
        let list = languageListRes?.payload?.payload?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setLanguagesList(list);
      } else {
        setLanguagesList([]);
      }
      setIsLanguageListLoading(false)
    }
  }, [languageListRes]);

  useEffect(() => {
    if (!_.isEmpty(fileRes) && apiCalled) {
      if (fileRes?.status === "success") {
        if (sectionType === "thumbnail") {
          setThumbnail(fileRes?.file_url);
          formikRef.current.setFieldValue("thumbnail", fileRes?.file_url);
        } else if (sectionType === "banner") {
          setBanner(fileRes?.file_url);
          formikRef.current.setFieldValue("banner", fileRes?.file_url);
        } else if (sectionType === "prerequisites") {
          let obj = {
            id: Math.round(Math.random() * 9999),
            name: fileRes?.name,
            type: fileRes?.type,
            url: fileRes?.file_url,
            dateModified: fileRes?.dateModified,
            size: fileRes?.size,
          };

          setPrerequisites((prevPrerequisites) => [...prevPrerequisites, obj]);
          setIsPreqLoading(false);
        } else if (sectionType === "resource") {
          // console.log('RESOURCE', fileRes)
          let obj = {
            id: Math.round(Math.random() * 9999),
            name: fileRes?.name,
            type: fileRes?.type,
            url: fileRes?.file_url,
            dateModified: fileRes?.dateModified,
            size: fileRes?.size,
          };

          setResource((resource) => [...resource, obj]);
          setIsResourceLoading(false);
        }
        setIsLoading(false);
      } else {
        setError(t("uploadFailed"));
        setShowLimitPopup(true);
        setIsLoading(false);
      }
    }
    setApiCalled(false);
  }, [fileRes]);

  const validateKickoffDate = (
    sessionArray,
    kickoffStartDate, kickoffEndDate,
    kickoffStartTime, kickoffEndTime,
  ) => {
    if (!_.isEmpty(sessionArray)) {
      const sortedSessionArray = _.sortBy(sessionArray, 'sessionStartDateTime').reverse()
      const sessionStartDate = moment(sortedSessionArray[0].sessionStartDateTime, 'YYYY-MM-DD HH:mm');
      const kickoffStartDateM = moment(kickoffStartDate).format('DD/MM/YYYY');
      const kickoffEndDateM = moment(kickoffEndDate).format('DD/MM/YYYY');
      const kickoffStartDateTime = moment(`${kickoffStartDateM} ${kickoffStartTime}`, 'DD/MM/YYYY HH:mm');
      const kickoffEndDateTime = moment(`${kickoffEndDateM} ${kickoffEndTime}`, 'DD/MM/YYYY HH:mm');

      if (kickoffStartDateTime.isBefore(sessionStartDate)) {
        return true
      }
    }
    return false
  }

  const getAllTrainerListing = () => {
    dispatch(
      getTrainers({
        module: "getAllTrainers",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || "",
        },
      })
    );
  }

  const getMembersListing = () => {
    dispatch(
      getMembers({
        module: "getAllMemebers",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || "",
        },
      })
    );
  }

  const postWorkshopTimezoneListing = () => {
    setIsTimezoneListLoading(true)
    dispatch(
      postWorkshopTimezone({
        module: "getAllTimeZone",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || "",
        },
      })
    );
  }

  const getLanguageListing = () => {
    setIsLanguageListLoading(true)
    dispatch(
      getLanguages({
        module: "getLanguages",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      })
    );
  }

  // const handleChange = (event) => {
  //   const selectedId = event.target.id; // Get the currently clicked radio button
  //   setSelectedOption(selectedId); // Update state    
  //   if (selectedId === "flexRadioDefault2") {
  //     handleRecurringSessionClick();
  //   }
  // };

  const handleRecurringSessionClick = (name, value) => {
    if (formikRef.current) {
      const { setFieldValue, values } = formikRef.current;

      // Remove additional cards if "recurring" is selected
      setFieldValue("cards", [1]);
      setFieldValue("sessionStartDate", [values.sessionStartDate[0]]);
      setFieldValue("sessionEndDate", [values.sessionEndDate[0]]);
      setFieldValue("sessionStartTime", [values.sessionStartTime[0]]);
      setFieldValue("sessionEndTime", [values.sessionEndTime[0]]);
      setFieldValue("sessionURL", [values.sessionURL[0]]);
      setFieldValue(name, value);
    }
  };

  const handleInputChange = (e, trainerIds) => {
    const value = e.target.value;
    if (value === "" && _.isEmpty(selectedTrainerId)) {
      setTrainerValidation(t("trainerNameRequired"));
    } else {
      setTrainerValidation("");
    }
    setInputValue(value);
    setShowSuggestions(true); // Show dropdown when typing

    if (value.trim() !== "") {
      const suggestions = trainersList.filter((trainer) =>
        !trainerIds.includes(trainer.id) &&
        trainer.display_name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(suggestions);
    } else {
      setFilteredSuggestions([]);
    }
  };

  const handleInputChangeParticipant = (e, participantIds) => {
    const value = e.target.value;
    if (value === "") {
      setMemberValidation(t("participantNameRequired"));
    } else {
      setMemberValidation("");
    }
    setInputValueParticipant(value);
    setShowSuggestionsParticipants(true); // Show dropdown when typing

    if (value.trim() !== "") {
      const suggestions = membersList.filter((member) => {
        const firstName = member.first_name
          ? member.first_name.toLowerCase()
          : "";
        const lastName = member.last_name ? member.last_name.toLowerCase() : "";
        const fullName = `${firstName} ${lastName}`.trim();
        return !participantIds.includes(member.id) && fullName.includes(value.toLowerCase());
      });
      setFilteredSuggestionsParticipant(suggestions);
    } else {
      setFilteredSuggestionsParticipant([]);
    }
  };

  // const handleSuggestionClick = (trainer) => {
  //   if (!chips.find((chip) => chip.id === trainer.id)) {
  //     setChips((prev) => [...prev, trainer]);
  //     setSelectedTrainerId((prevTrainer) => [...prevTrainer, trainer.id]);
  //   }
  //   setInputValue(""); // Clear input field after selection
  //   setShowSuggestions(false); // Hide dropdown
  // };

  // const handleSuggestionClickParticipant = (participant) => {
  //   if (!participantChips.find((chip) => chip.id === participant.id)) {
  //     setParticipantChips((prev) => [...prev, participant]);
  //     setSelectedParticipantId((prevParticipant) => [
  //       ...new Set([...prevParticipant, participant.id]), // Ensuring no duplicates
  //     ]);
  //   }
  //   setInputValueParticipant(""); // Clear input field after selection
  //   setShowSuggestionsParticipants(false); // Hide dropdown
  // };

  const handleFileChange = (e) => {
    if (e.target.files[0] !== undefined && e.target.files[0] !== null) {
      const selectedFiles = e.target.files;
      const allowedExtensions = [
        "png",
        "jpeg",
        "mp4",
        "3ggp",
        "m3u8",
        "avi",
        "mov",
        "mkv",
        "flv",
        "wmv",
      ];
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];

        // Get the file details
        const fileName = file.name;
        const fileSize = file.size; // in bytes
        const fileType = file.type;
        const fileLastModified = file.lastModified;
        if (
          allowedExtensions.includes(fileType) ||
          _.toLower(fileType).includes("video")
        ) {
          setError(t("invalidFileType"));
          setShowLimitPopup(true);
        } else if (fileSize > 20 * 1048576) {
          setError(t("fileSizeError"));
          setShowLimitPopup(true);
        } else {
          setError("");
          setSectionType("prerequisites");
          setIsPreqLoading(true);
          callS3API(file, fileType, fileName, fileSize, fileLastModified);
        }
      }
    }
  };

  const handleResourceFileChange = (e) => {
    setSectionType("resource");
    if (e.target.files[0] !== undefined && e.target.files[0] !== null) {
      const selectedFiles = e.target.files;
      const allowedExtensions = [
        "png",
        "jpeg",
        "mp4",
        "3ggp",
        "m3u8",
        "avi",
        "mov",
        "mkv",
        "flv",
        "wmv",
      ];
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];

        // Get the file details
        const fileName = file.name;
        const fileSize = file.size; // in bytes
        const fileType = file.type;
        const fileLastModified = file.lastModified;

        if (
          allowedExtensions.includes(fileType) ||
          _.toLower(fileType).includes("video")
        ) {
          setError(t("invalidFileType"));
          setShowLimitPopup(true);
        } else if (fileSize > 20 * 1048576) {
          setError(t("fileSizeError"));
          setShowLimitPopup(true);
        } else {
          setError("");
          setIsResourceLoading(true);
          callS3API(file, fileType, fileName, fileSize, fileLastModified);
        }
      }
    }
  };

  const handleThumbnailUploadClick = () => {
    document.getElementById("exampleThumbnailCover").click();
  };

  const handleBannerUploadClick = () => {
    document.getElementById("exampleBannerCover").click();
  };

  const handleThumbnailChange = (e) => {
    if (e.target.files[0] !== undefined && e.target.files[0] !== null) {
      // Handle the file upload logic here
      let file = e.target.files[0];
      const fileName = file.name;
      const fileSize = file.size; // in bytes
      const fileType = file.type;
      const fileLastModified = file.lastModified;
      if (file.size > 1048576) {
        // 1 MB in bytes
        setError(t("fileSizeError1mb"));
        setShowLimitPopup(true);
        e.target.value = ""; // clear the file input
        file = "";
      } else {
        let height = "";
        let width = "";
        if (file) {
          const img = new Image(); // Create an Image object
          img.src = URL.createObjectURL(file); // Create an object URL for the file

          img.onload = () => {
            // Get the dimensions once the image is loaded

            height = img.height;
            width = img.width;
            if (width > 516 || height > 325) {
              setError(t("imageDimensionError"));
              setShowLimitPopup(true);
            } else {
              setSectionType("thumbnail");
              setIsLoading(true);
              callS3API(file, fileType, fileName, fileSize, fileLastModified);
            }
            URL.revokeObjectURL(img.src); // Free up memory
          };
        }
      }
    }
  };

  const handleBannerChange = (e) => {
    if (e.target.files[0] !== undefined && e.target.files[0] !== null) {
      // Handle the file upload logic here
      let file = e.target.files[0];
      const fileName = file.name;
      const fileSize = file.size; // in bytes
      const fileType = file.type;
      const fileLastModified = file.lastModified;

      if (file.size > 1048576) {
        // 1 MB in bytes
        setShowLimitPopup(true);
        e.target.value = ""; // clear the file input
        file = "";
      } else {
        let height = "";
        let width = "";
        if (file) {
          const img = new Image(); // Create an Image object
          img.src = URL.createObjectURL(file); // Create an object URL for the file

          img.onload = () => {
            // Get the dimensions once the image is loaded

            height = img.height;
            width = img.width;
            if (width > 1920 || height > 360) {
              setError(t("imageDimensionError1920"));
              setShowLimitPopup(true);
            } else {
              setSectionType("banner");
              setIsLoading(true);
              callS3API(file, fileType, fileName, fileSize, fileLastModified);
            }
            URL.revokeObjectURL(img.src); // Free up memory
          };
        }
      }
    }
  };

  const callS3API = (file, type, name, size, dateModified) => {
    setApiCalled(true);
    // setIsLoading(true);
    let fileType = type?.includes("pdf")
      ? "pdf"
      : type?.includes("image")
        ? "image"
        : "pdf";
    const formData = new FormData();
    formData.append(
      "token",
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
    );
    formData.append("file", file);
    formData.append("type", fileType);
    formData.append("dateModified", dateModified);
    dispatch(getFileUploadOnAWS(formData));
  };

  const downloadPDF = async (pdfUrl, name) => {
    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name}`); // Specify the name for the downloaded file
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link); // Clean up the DOM
    } catch (error) {
      console.error("Failed to download PDF:", error);
    }
  };

  const deleteFileFromResourceList = (id) => {
    let updatedResources = resource.filter((item) => item?.id != id);
    setResource(updatedResources);
    document.getElementById('file2').value = '';
  };

  const deleteFileFromPrequisitesList = (id) => {
    let updatedPrequisites = prerequisites.filter((item) => item?.id != id);
    setPrerequisites(updatedPrequisites);
  };

  // const removeChip = (idToRemove) => {
  //   setChips(chips.filter((chip) => chip.id !== idToRemove));
  //   setSelectedTrainerId((prev) => prev.filter((id) => id !== idToRemove));
  // };

  // const removeParticipantChip = (idToRemove) => {
  //   // Filter chips and remove the one with matching id
  //   setParticipantChips(
  //     participantChips.filter((chip) => chip.id !== idToRemove)
  //   );
  //   // Also remove from selectedParticipantId array
  //   setSelectedParticipantId((prev) => prev.filter((id) => id !== idToRemove));
  // };

  const renderSessionCard = (
    session, index, values, remove,
  ) => {
    return (
      <div
        key={index}
        className="cardrow"
      >
        <div className="row">
          {/* Session Name */}

          <div className="form-container">
            {/* Render Cards Dynamically */}
            <div
              className=" card frminersel mt-4"
            >
              <div className="d-flex justify-content-end gap-3 w-100">
                {/* Remove Button */}
                {values.sessionArray.length > 1 && (
                  <span
                    title="Remove"
                    onClick={() => remove(index)}
                  >
                    <svg
                      className="cursor-pointer iconde"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="23"
                      viewBox="0 0 20 23"
                      fill="none"
                    >
                      <path
                        d="M7.28571 17.2461C7.28571 17.6328 6.94643 17.9336 6.60714 17.9336C6.22545 17.9336 5.92857 17.6328 5.92857 17.2461V8.30859C5.92857 7.96484 6.22545 7.62109 6.60714 7.62109C6.94643 7.62109 7.28571 7.96484 7.28571 8.30859V17.2461ZM10.6786 17.2461C10.6786 17.6328 10.3393 17.9336 10 17.9336C9.6183 17.9336 9.32143 17.6328 9.32143 17.2461V8.30859C9.32143 7.96484 9.6183 7.62109 10 7.62109C10.3393 7.62109 10.6786 7.96484 10.6786 8.30859V17.2461ZM14.0714 17.2461C14.0714 17.6328 13.7321 17.9336 13.3929 17.9336C13.0112 17.9336 12.7143 17.6328 12.7143 17.2461V8.30859C12.7143 7.96484 13.0112 7.62109 13.3929 7.62109C13.7321 7.62109 14.0714 7.96484 14.0714 8.30859V17.2461ZM13.9442 1.13281L15.5134 3.49609H18.4822C19.0334 3.49609 19.5 3.96875 19.5 4.52734C19.5 5.1289 19.0334 5.55859 18.4822 5.55859H18.1429V18.6211C18.1429 20.5547 16.616 22.0586 14.75 22.0586H5.25C3.34152 22.0586 1.85714 20.5547 1.85714 18.6211V5.55859H1.51786C0.924108 5.55859 0.5 5.1289 0.5 4.52734C0.5 3.96875 0.924108 3.49609 1.51786 3.49609H4.44419L6.0134 1.13281C6.4375 0.488284 7.20089 0.0585938 8.0067 0.0585938H11.9509C12.7567 0.0585938 13.5201 0.488284 13.9442 1.13281ZM6.90402 3.49609H13.0536L12.2477 2.29297C12.2054 2.20703 12.0782 2.12109 11.9509 2.12109H8.0067C7.87946 2.12109 7.75224 2.20703 7.70982 2.29297L6.90402 3.49609ZM3.89286 18.6211C3.89286 19.3945 4.4866 19.9961 5.25 19.9961H14.75C15.471 19.9961 16.1071 19.3945 16.1071 18.6211V5.55859H3.89286V18.6211Z"
                        fill="#dc3545"
                      />
                    </svg>
                  </span>
                )}
              </div>
              <SessionCardForm
                // values={values}
                index={index}
                session={session}
                timezoneList={timezoneList}
                languageList={languageList}
                isLanguageListLoading={isLanguageListLoading}
                isTimezoneListLoading={isTimezoneListLoading}
                sessionOnlyUpdate={sessionOnlyUpdate}
              // errors={errors}
              // touched={touched}
              // handleChange={handleChange}
              // handleBlur={handleBlur}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  const renderWorkshopPrerequisites = (values, touched, errors, setFieldValue) => {
    // {/* Workshop  Prerequisites */ }
    return (
      <Col md={12} className="mt-3" >
        <div className="card">
          <h5 className="card-title mb-3">
            {t("workshopPrerequisites")}
          </h5>
          <div className="row g-3 w-100">
            {/* Map through URLs */}
            <FieldArray name="urls">
              {({ remove, push }) => (
                <>
                  {values.urls.map((url, index) => (
                    <div key={index} className="col-md-12 mb-0">
                      <label
                        htmlFor={`urls[${index}]`}
                        className="form-label"
                      >
                        URL {index + 1}{" "}
                      </label>
                      {/* Use Field for Formik integration */}
                      <div className="d-flex gap-3 align-items-center">
                        <Field
                          name={`urls[${index}]`}
                          type="text"
                          className={`form-control ${touched.urls?.[index] &&
                            errors.urls?.[index]
                            ? "is-invalid"
                            : ""
                            }`}
                          placeholder="Enter URL"
                          disabled={sessionOnlyUpdate}
                        />
                        {values.urls.length > 1 && (
                          <span
                            title="Remove"
                            onClick={() => remove(index)}
                          >
                            <svg
                              className="cursor-pointer iconde"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="23"
                              viewBox="0 0 20 23"
                              fill="none"
                            >
                              <path
                                d="M7.28571 17.2461C7.28571 17.6328 6.94643 17.9336 6.60714 17.9336C6.22545 17.9336 5.92857 17.6328 5.92857 17.2461V8.30859C5.92857 7.96484 6.22545 7.62109 6.60714 7.62109C6.94643 7.62109 7.28571 7.96484 7.28571 8.30859V17.2461ZM10.6786 17.2461C10.6786 17.6328 10.3393 17.9336 10 17.9336C9.6183 17.9336 9.32143 17.6328 9.32143 17.2461V8.30859C9.32143 7.96484 9.6183 7.62109 10 7.62109C10.3393 7.62109 10.6786 7.96484 10.6786 8.30859V17.2461ZM14.0714 17.2461C14.0714 17.6328 13.7321 17.9336 13.3929 17.9336C13.0112 17.9336 12.7143 17.6328 12.7143 17.2461V8.30859C12.7143 7.96484 13.0112 7.62109 13.3929 7.62109C13.7321 7.62109 14.0714 7.96484 14.0714 8.30859V17.2461ZM13.9442 1.13281L15.5134 3.49609H18.4822C19.0334 3.49609 19.5 3.96875 19.5 4.52734C19.5 5.1289 19.0334 5.55859 18.4822 5.55859H18.1429V18.6211C18.1429 20.5547 16.616 22.0586 14.75 22.0586H5.25C3.34152 22.0586 1.85714 20.5547 1.85714 18.6211V5.55859H1.51786C0.924108 5.55859 0.5 5.1289 0.5 4.52734C0.5 3.96875 0.924108 3.49609 1.51786 3.49609H4.44419L6.0134 1.13281C6.4375 0.488284 7.20089 0.0585938 8.0067 0.0585938H11.9509C12.7567 0.0585938 13.5201 0.488284 13.9442 1.13281ZM6.90402 3.49609H13.0536L12.2477 2.29297C12.2054 2.20703 12.0782 2.12109 11.9509 2.12109H8.0067C7.87946 2.12109 7.75224 2.20703 7.70982 2.29297L6.90402 3.49609ZM3.89286 18.6211C3.89286 19.3945 4.4866 19.9961 5.25 19.9961H14.75C15.471 19.9961 16.1071 19.3945 16.1071 18.6211V5.55859H3.89286V18.6211Z"
                                fill="#dc3545"
                              ></path>
                            </svg>
                          </span>
                        )}
                      </div>
                      <ErrorMessage
                        name={`urls[${index}]`}
                        component="div"
                        className="invalid-feedback"
                      />
                      {/* Remove Button */}
                    </div>
                  ))}
                  {/* <ErrorMessage
                name={`urls`}
                component="div"
                className="invalid-feedback"
              /> */}
                  {/* Add URL Button */}
                  <div className="col-md-12 mb-3 mt-2">
                    <button
                      type="button"
                      className="link-btn"
                      onClick={async () => {
                        const isValidURL = await httpUrlSchema.isValid(values.urls[values.urls.length - 1])
                        if (isValidURL) {
                          push("")
                        } else {
                          setErrorMsgPreqURL("Please enter valid url, before adding more URLs.")
                        }
                      }}
                    >
                      + Add URL
                    </button>
                    <div className="invalid-feedback">{errorMsgPreqURL}</div>
                  </div>
                </>
              )}
            </FieldArray>
          </div>

          <div
            className={`file-uploader mt-0  ${sessionOnlyUpdate ? "cursor-not-allowed" : "cursor-pointer"}`}
            onClick={() =>
              document.getElementById("file1").click()
            }
          >
            <div className="iocn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="18"
                viewBox="0 0 24 18"
                fill="none"
              >
                <path
                  d="M11.3691 6.05273C11.7031 5.71875 12.2598 5.71875 12.5938 6.05273L15.5625 9.02148C15.9336 9.39257 15.9336 9.94921 15.5625 10.2832C15.2285 10.6543 14.6719 10.6543 14.3379 10.2832L12.8906 8.83593V13.8086C12.8906 14.3281 12.4824 14.6992 12 14.6992C11.4805 14.6992 11.1094 14.3281 11.1094 13.8086V8.83593L9.625 10.2832C9.29102 10.6543 8.73438 10.6543 8.40039 10.2832C8.0293 9.94921 8.0293 9.39257 8.40039 9.02148L11.3691 6.05273ZM5.46875 17.3711C2.5 17.3711 0.125 14.9961 0.125 12.0274C0.125 9.72656 1.60938 7.72265 3.6875 7.01757V6.98047C3.6875 3.5664 6.4707 0.746094 9.92188 0.746094C11.7773 0.746094 13.4844 1.59961 14.6348 2.93554C15.1914 2.67578 15.7852 2.52734 16.4531 2.52734C18.9023 2.52734 20.9062 4.53125 20.9062 6.98047C20.9062 7.24023 20.8691 7.46289 20.832 7.72265C22.6133 8.50195 23.875 10.2832 23.875 12.3242C23.875 15.0332 21.7598 17.2227 19.125 17.3711H5.46875ZM9.92188 2.52734C7.43555 2.52734 5.46875 4.53125 5.46875 6.98047V8.27929L4.24414 8.6875C2.87109 9.16992 1.90625 10.5059 1.90625 12.0274C1.90625 13.9941 3.46484 15.5898 5.46875 15.5898H18.9023H19.0137C20.7207 15.5156 22.0938 14.0684 22.0938 12.3242C22.0938 10.9883 21.2773 9.83789 20.127 9.35547L18.8652 8.79882L19.0879 7.42578C19.0879 7.27734 19.125 7.1289 19.125 6.98047C19.125 5.5332 17.9004 4.30859 16.4531 4.30859C16.0449 4.30859 15.6738 4.41992 15.3398 4.56836L14.1523 5.08789L13.2617 4.08593C12.4453 3.1582 11.2578 2.52734 9.88477 2.52734H9.92188Z"
                  fill="#2D2D2D"
                />
              </svg>
            </div>
            <div className="textf">FILE FORMAT(S)</div>
            <div className="filemsg">
              {t("dropUpTo20MBFilesHereToUploadOr")}
            </div>
            <label
              for="file-upload"
              className={`upload-link chossefiles ${sessionOnlyUpdate ? "cursor-not-allowed" : ""}`}
            >
              {t("chooseFiles")}
            </label>
            <input
              type="file"
              id="file1"
              className={`upload-input ${sessionOnlyUpdate ? "cursor-not-allowed" : ""}`}
              accept=".pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx"
              onChange={handleFileChange}
              disabled={sessionOnlyUpdate}
            />

            <div className="w-100">
              {prerequisites?.map((item) => {
                return (
                  <ul className="listinguploadee  mt-4">
                    <li>
                      <span className="lef-infopx">
                        <span className="iconxload">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="23"
                            viewBox="0 0 18 23"
                            fill="none"
                          >
                            <path
                              d="M16.4336 4.09765L13.2109 0.875004C12.6953 0.359374 12.0078 0.0585938 11.2773 0.0585938H3.5C1.95312 0.0585938 0.75 1.30468 0.75 2.80859V19.3086C0.75 20.8555 1.95312 22.0586 3.5 22.0586H14.5C16.0039 22.0586 17.25 20.8555 17.25 19.3086V6.03125C17.25 5.30078 16.9492 4.61328 16.4336 4.09765ZM15.1875 19.3086C15.1875 19.6953 14.8438 19.9961 14.5 19.9961H3.5C3.11328 19.9961 2.8125 19.6953 2.8125 19.3086V2.85156C2.8125 2.46484 3.11328 2.16406 3.5 2.16406H10.375V5.55859C10.375 6.33203 10.9766 6.93359 11.75 6.93359H15.1445V19.3086H15.1875ZM9.98828 12.6055C9.77344 12.6055 9.60156 12.7344 9.47266 12.9063L7.79688 15.4414L7.28125 14.7109C7.15234 14.5391 6.98047 14.4102 6.76562 14.4102C6.59375 14.4102 6.37891 14.5391 6.29297 14.7109L4.27344 17.7188C4.14453 17.8906 4.14453 18.1484 4.23047 18.3203C4.35938 18.5352 4.53125 18.6211 4.74609 18.6211H13.168C13.3828 18.6211 13.5977 18.5352 13.6836 18.3203C13.7695 18.1484 13.7695 17.8906 13.6406 17.7188L10.4609 12.9063C10.375 12.7344 10.2031 12.6055 9.98828 12.6055ZM6.25 12.4336C6.98047 12.4336 7.625 11.832 7.625 11.0586C7.625 10.3281 6.98047 9.68359 6.25 9.68359C5.47656 9.68359 4.875 10.3281 4.875 11.0586C4.875 11.832 5.47656 12.4336 6.25 12.4336Z"
                              fill="#2D2D2D"
                            />
                          </svg>
                        </span>
                        <span className="filename">
                          {item?.name}
                        </span>
                      </span>
                      <span className="rightds">
                        <span className="filtduploaddate">
                          {item?.dateModified &&
                            dateTimeStamp(
                              item?.dateModified
                            ) + " | "}
                          {item?.size > 0 && (
                            (item?.size /
                              (1024 * 1024)).toFixed(2) + 'MB')}
                        </span>
                        <span className="downloandicon d-flex gap-2">
                          <svg
                            className="cursor-pointer iconde"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="23"
                            viewBox="0 0 20 23"
                            fill="none"
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadPDF(
                                item?.url,
                                item?.name
                              );
                            }}
                          >
                            <path
                              d="M15.5 22.0586H4.5C2.17969 22.0586 0.375 20.2539 0.375 17.9336V14.8398C0.375 14.2813 0.804688 13.8086 1.40625 13.8086C1.96484 13.8086 2.4375 14.2813 2.4375 14.8398V17.9336C2.4375 19.0938 3.33984 19.9961 4.5 19.9961H15.5C16.6172 19.9961 17.5625 19.0938 17.5625 17.9336V14.8398C17.5625 14.2813 17.9922 13.8086 18.5938 13.8086C19.1523 13.8086 19.625 14.2813 19.625 14.8398V17.9336C19.625 20.2109 17.7773 22.0586 15.5 22.0586ZM10.6875 14.9258L16.5312 9.42579C16.9609 9.03906 16.9609 8.39453 16.5742 7.96484C16.1875 7.53515 15.543 7.53515 15.1133 7.92187L11.0312 11.7891V1.08984C11.0312 0.531254 10.5586 0.0585938 10 0.0585938C9.39844 0.0585938 8.96875 0.531254 8.96875 1.08984V11.7891L4.84375 7.92187C4.41406 7.53515 3.76953 7.53515 3.38281 7.96484C3.21094 8.17968 3.125 8.4375 3.125 8.65234C3.125 8.95312 3.21094 9.21093 3.42578 9.42579L9.26953 14.9258C9.65625 15.3125 10.3008 15.3125 10.6875 14.9258Z"
                              fill="#2D2D2D"
                            />
                          </svg>
                          <svg
                            className={`${sessionOnlyUpdate ? "cursor-not-allowed" : "cursor-pointer"} iconde`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="23"
                            viewBox="0 0 20 23"
                            fill="none"
                            onClick={(e) => {
                              e.stopPropagation();
                              !sessionOnlyUpdate && deleteFileFromPrequisitesList(
                                item?.id
                              )
                            }}
                          >
                            <path
                              d="M7.28571 17.2461C7.28571 17.6328 6.94643 17.9336 6.60714 17.9336C6.22545 17.9336 5.92857 17.6328 5.92857 17.2461V8.30859C5.92857 7.96484 6.22545 7.62109 6.60714 7.62109C6.94643 7.62109 7.28571 7.96484 7.28571 8.30859V17.2461ZM10.6786 17.2461C10.6786 17.6328 10.3393 17.9336 10 17.9336C9.6183 17.9336 9.32143 17.6328 9.32143 17.2461V8.30859C9.32143 7.96484 9.6183 7.62109 10 7.62109C10.3393 7.62109 10.6786 7.96484 10.6786 8.30859V17.2461ZM14.0714 17.2461C14.0714 17.6328 13.7321 17.9336 13.3929 17.9336C13.0112 17.9336 12.7143 17.6328 12.7143 17.2461V8.30859C12.7143 7.96484 13.0112 7.62109 13.3929 7.62109C13.7321 7.62109 14.0714 7.96484 14.0714 8.30859V17.2461ZM13.9442 1.13281L15.5134 3.49609H18.4822C19.0334 3.49609 19.5 3.96875 19.5 4.52734C19.5 5.1289 19.0334 5.55859 18.4822 5.55859H18.1429V18.6211C18.1429 20.5547 16.616 22.0586 14.75 22.0586H5.25C3.34152 22.0586 1.85714 20.5547 1.85714 18.6211V5.55859H1.51786C0.924108 5.55859 0.5 5.1289 0.5 4.52734C0.5 3.96875 0.924108 3.49609 1.51786 3.49609H4.44419L6.0134 1.13281C6.4375 0.488284 7.20089 0.0585938 8.0067 0.0585938H11.9509C12.7567 0.0585938 13.5201 0.488284 13.9442 1.13281ZM6.90402 3.49609H13.0536L12.2477 2.29297C12.2054 2.20703 12.0782 2.12109 11.9509 2.12109H8.0067C7.87946 2.12109 7.75224 2.20703 7.70982 2.29297L6.90402 3.49609ZM3.89286 18.6211C3.89286 19.3945 4.4866 19.9961 5.25 19.9961H14.75C15.471 19.9961 16.1071 19.3945 16.1071 18.6211V5.55859H3.89286V18.6211Z"
                              fill="#2D2D2D"
                            />
                          </svg>
                        </span>
                      </span>
                    </li>
                  </ul>
                );
              })}
              {isPreqLoading && (
                <ul className="listinguploadee mt-4 ">
                  <ShimmerScreen
                    case="rect"
                    height="0.3125rem"
                    width="100%"
                  />
                </ul>
              )}
            </div>
          </div>
        </div>
      </Col >
    )
  }

  const handleValidationScrolling = (values, setFieldTouched) => {
    if (!values.workshopName) {
      // alert('Please enter workshop name')
      setFieldTouched("workshopName", true)
      document.getElementById("workshopName").scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    } else if (_.isEmpty(values.trainerIds)) {
      // alert('Please select at least one trainer')
      setFieldTouched("trainerIds", true)
      document.getElementById('trainerName').scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }
    if (!_.isEmpty(values.sessionArray)) {
      let flag = false
      for (let [index, session] of values.sessionArray.entries()) {
        if (!session.sessionName || !session.sessionStartDate ||
          !session.sessionEndDate || !session.sessionStartTime ||
          !session.sessionEndTime || !session.sessionURL ||
          !session.sessionTimezone || !session.sessionLanguage
        ) {
          flag = true
          setFieldTouched(`sessionArray[${index}].sessionName`, true)
          setFieldTouched(`sessionArray[${index}].sessionStartDate`, true)
          setFieldTouched(`sessionArray[${index}].sessionEndDate`, true)
          setFieldTouched(`sessionArray[${index}].sessionStartTime`, true)
          setFieldTouched(`sessionArray[${index}].sessionEndTime`, true)
          setFieldTouched(`sessionArray[${index}].sessionURL`, true)
          setFieldTouched(`sessionArray[${index}].sessionTimezone`, true)
          setFieldTouched(`sessionArray[${index}].sessionLanguage`, true)
        }
      }

      if (flag) {
        document.getElementById("sessionArray").scrollIntoView({
          behavior: "smooth",
          block: "center",
          top: 20
        });
        return;
      }
    }
    // if (!values.timezone) {
    //   // alert('Please select a timezone')
    //   setFieldTouched("timezone", true)
    //   document.getElementById("timezone").scrollIntoView({
    //     behavior: "smooth",
    //     block: "center",
    //     top: 20
    //   });
    //   return;
    // } 
    // else if (!values.language) {
    //   // alert('Please select a language')
    //   setFieldTouched("language", true)
    //   document.getElementById("language").scrollIntoView({
    //     behavior: "smooth",
    //     block: "center",
    //     top: 20
    //   });
    // } 
    // else 
    if (_.isEmpty(values.participantIds)) {
      // alert('Please select at least one participant')
      setFieldTouched("participantIds", true)
      document.getElementById("participant").scrollIntoView({
        behavior: "smooth",
        block: "center",
        top: 20
      });
      return;
    } else if (!values.status) {
      // alert('Please select a status')
      setFieldTouched("status", true)
      document.getElementById("status").scrollIntoView({
        behavior: "smooth",
        block: "center",
        top: 20
      });
      return;
    } else if (!values.description) {
      // alert('Please enter workshop description')
      setFieldTouched("description", true)
      document.getElementById("description").scrollIntoView({
        behavior: "smooth",
        block: "center",
        top: 20
      });
      return;
    } else if (isChecked) {
      // alert('Please select a kickoff session')
      if (
        !values.kickOffSession.sessionStartDate || !values.kickOffSession.sessionEndDate ||
        !values.kickOffSession.sessionStartTime || !values.kickOffSession.sessionEndTime ||
        !values.kickOffSession.sessionURL || !values.kickOffSession.sessionTimezone ||
        !values.kickOffSession.sessionLanguage
      ) {
        setFieldTouched("kickOffSession.sessionStartDate", true)
        setFieldTouched("kickOffSession.sessionEndDate", true)
        setFieldTouched("kickOffSession.sessionStartTime", true)
        setFieldTouched("kickOffSession.sessionEndTime", true)
        setFieldTouched("kickOffSession.sessionURL", true)
        setFieldTouched("kickOffSession.sessionTimezone", true)
        setFieldTouched("kickOffSession.sessionLanguage", true)
        document.getElementById("kickoffarea").scrollIntoView({
          behavior: "smooth",
          block: "center",
          top: 20
        });
        return;
      }
    }
  }

  const handlePayload = (formikValues) => {
    let values = _.cloneDeep(formikValues)
    console.log("values", values)
    console.log("prerequisites", prerequisites)
    console.log("resource", resource)
    let kickoffSessionPresent = isChecked
    let workshopPreq = _.cloneDeep(prerequisites)
    let sessionArray = _.cloneDeep(values.sessionArray)

    if (!_.isEmpty(workshopData) && sessionOnlyUpdate) {
      // Check if session is kickoff session
      const kickoffArr = _.filter(sessionArray, session => session.isKickoffSession)
      
      if (kickoffArr.length > 0) {
        values.kickOffSession.sessionId = kickoffArr[0].sessionId
        values.kickOffSession.segmentId = kickoffArr[0].segmentId
        values.kickOffSession.sessionStartDate = kickoffArr[0].sessionStartDate
        values.kickOffSession.sessionEndDate = kickoffArr[0].sessionEndDate
        values.kickOffSession.sessionStartTime = kickoffArr[0].sessionStartTime
        values.kickOffSession.sessionEndTime = kickoffArr[0].sessionEndTime
        values.kickOffSession.sessionURL = kickoffArr[0].sessionURL
        values.kickOffSession.sessionTimezone = kickoffArr[0].sessionTimezone
        values.kickOffSession.sessionLanguage = kickoffArr[0].sessionLanguage
        values.kickOffSession.modeOfAttendance = kickoffArr[0].modeOfAttendance
        values.kickOffSession.sessionAddress = kickoffArr[0].sessionAddress
        sessionArray = []
        values.sessionArray = []
        kickoffSessionPresent = true
      }
    }

    if (!_.isEmpty(values.urls)) {
      for (let u of values.urls) {
        if (u) {
          workshopPreq.push({
            name: u,
            url: u,
            type: "url",
          })
        }
      }
    }
    
    const payload = {
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      workshop_name: values.workshopName,
      description: values.description,
      trainers: values.trainerIds,
      participates: values.participantIds,
      status: values.status,
      // language_id: values.language,
      thumbnail: values.thumbnail ? values.thumbnail : 'https://cdnstg.training.com/halifax/image/10543/2058509172-20241212.png',
      banner: values.banner ? values.banner : 'https://cdnstg.training.com/halifax/image/10543/2016513182-20241212.png',
      workshop_prerequisites: workshopPreq,
      workshop_resource: resource,
      delivery_mode: values.deliveryMode,
      // timezone: values.timezone,
      session_title: _.map(sessionArray, 'sessionName'),
      start_date: _.map(sessionArray, 'sessionStartDate'),
      event_enddate: _.map(sessionArray, 'sessionEndDate'),
      start_time: _.map(sessionArray, 'sessionStartTime'),
      end_time: _.map(sessionArray, 'sessionEndTime'),
      timezone: _.map(sessionArray, 'sessionTimezone'),
      language: _.map(sessionArray, 'sessionLanguage'),
      meeting_url: _.map(sessionArray, 'sessionURL'),
      mode_of_attendance: _.map(sessionArray, 'modeOfAttendance'),
      session_address: _.map(sessionArray, 'sessionAddress'),
      event_days: (sessionArray.length).toString(),
      create_session: !_.isEmpty(workshopData) ? "0" : "1",
      kickoffSessionKey: kickoffSessionPresent ? "1" : "0",
      kickoff_start_date: kickoffSessionPresent ? values.kickOffSession.sessionStartDate : "",
      kickoff_end_date: kickoffSessionPresent ? values.kickOffSession.sessionEndDate : "",
      kickoff_start_time: kickoffSessionPresent ? values.kickOffSession.sessionStartTime : "",
      kickoff_end_time: kickoffSessionPresent ? values.kickOffSession.sessionEndTime : "",
      kickoff_modeofattendance: kickoffSessionPresent ? values.kickOffSession.modeOfAttendance : "",
      kickoff_address: kickoffSessionPresent ? values.kickOffSession.sessionAddress : "",
      kickoff_url: kickoffSessionPresent ? values.kickOffSession.sessionURL : "",      
      kickoff_timezone: kickoffSessionPresent ? values.kickOffSession.sessionTimezone : "",
      kickoff_language: kickoffSessionPresent ? values.kickOffSession.sessionLanguage : "",
      sessionlevel: values.sessionType === "recurring" ? 1 : "",
      make_recurring: values.sessionType === "recurring" ? 1 : "",
      recurring_type_0: values.sessionType === "recurring" ? values.frequency : "",
      daily_filter_0: values.sessionType === "recurring" ? values.nestedDaily : "",
      recur_weekly_on: values.sessionType === "recurring" ? values.recurOn : "",
      noofoccurances: values.sessionType === "recurring" ? values.rangeofoccurence : "",
      monthly_option: values.sessionType === "recurring" ? values.nestedMonthly : "",
      monthly_value: values.sessionType === "recurring" ? values.dayOfMonth : 1,
      monthly_option_number: values.sessionType === "recurring" ? values.firstSecondThird : "",
      monthly_option_week: values.sessionType === "recurring" ? values.dayWeekdayWeekend : "",
      month_number: values.sessionType === "recurring" ? values.monthName.toString() : "",
      is_draft: values.isDraft,
    }
    if (!_.isEmpty(workshopData)) {
      payload.session_ids = _.map(values.sessionArray, 'sessionId')
      payload.segment_ids = _.map(values.sessionArray, 'segmentId')

      if (values.sessionType === "recurring") {
        let sessionIds = []
        let segmentIds = []
        for (let session of workshopData.sessions_list) {
          if (session.kickoff_session !== "1") {
            sessionIds.push(session.session_id)
            segmentIds.push(session.segment_id)
          }
        }
        payload.session_ids = sessionIds
        payload.segment_ids = segmentIds
      }

      if (isChecked || kickoffSessionPresent) {
        payload.kickoffSession_id = values.kickOffSession.sessionId ? values.kickOffSession.sessionId : ""
        payload.kickoffSegment_id = values.kickOffSession.segmentId ? values.kickOffSession.segmentId : ""
      }
    }
    console.log("payload", payload)
    handleSubmitForm(payload)
  }

  return (
    <>
      <section className="group-worshopdetail-frm pt-4 pb-4">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <button className="mb-4 bck-btn" onClick={() => navigate(-1)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                  fill="none"
                >
                  <path
                    d="M7.42188 16.6262L0.273438 9.16523C0.078125 8.93086 0 8.69649 0 8.46211C0 8.2668 0.078125 8.03242 0.234375 7.83711L7.38281 0.376169C7.73438 -0.0144556 8.35938 -0.0144556 8.71094 0.337107C9.10156 0.688669 9.10156 1.27461 8.75 1.66523L2.22656 8.46211L8.78906 15.3371C9.14062 15.6887 9.14062 16.3137 8.75 16.6652C8.39844 17.0168 7.77344 17.0168 7.42188 16.6262Z"
                    fill="black"
                  />
                </svg>{" "}
                {t("back")}
              </button>
              <h1 className="lable-heading_search mb-0">{pageLine}</h1>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12">
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                validateOnChange={true}
                // onSubmit={(values) => {
                //   setFormValues(values);
                // }}
                onSubmit={handlePayload}
                innerRef={formikRef}
              >
                {({ errors, touched, dirty, setFieldValue, values, handleChange, handleBlur, isValid, setFieldTouched }) => {                    
                  // alert(isValid)
                  // SHRADESH CODE
                  if (_.isEmpty(values.trainerIds)) {
                    setTrainerValidation("Please select at least one trainer");
                  } else {
                    setTrainerValidation("");
                  }
                  if (_.isEmpty(values.participantIds)) {
                    setMemberValidation("Please select at least one participant");
                  } else {
                    setMemberValidation("");
                  }

                  if (!isValid && dirty) {
                    setIsFormDirty(true);
                  } else {
                    setIsFormDirty(false);
                  }



                  // END OF SHRADESH CODE


                  return (
                    <div className="row">
                      <div className="col-xl-8 col-12">
                        <FormikForm onSubmit={handlePayload} autoComplete="off">

                          {/* Workshop Name and Trainer Name */}
                          <div className="row g-3 mb-4">
                            <Col md={12}>
                              <label
                                htmlFor="workshopName"
                                className="form-label"
                              >
                                {t("NameOfWorkshop")}
                                <sup className="text-danger">*</sup>
                                <OverlayTrigger
                                  overlay={
                                    <Tooltip id="tooltip-disabled">
                                      {t("InfoTextWillComehere")}
                                    </Tooltip>
                                  }
                                >
                                  <span className="d-inline-block">
                                    <span className="info">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="15"
                                        viewBox="0 0 16 15"
                                        fill="none"
                                      >
                                        <path
                                          d="M8 0C3.83984 0 0.5 3.36914 0.5 7.5C0.5 11.6602 3.83984 15 8 15C12.1309 15 15.5 11.6602 15.5 7.5C15.5 3.36914 12.1309 0 8 0ZM8 13.5938C4.63086 13.5938 1.90625 10.8691 1.90625 7.5C1.90625 4.16016 4.63086 1.40625 8 1.40625C11.3398 1.40625 14.0938 4.16016 14.0938 7.5C14.0938 10.8691 11.3398 13.5938 8 13.5938ZM9.17188 9.8438H8.70312V7.26562C8.70312 6.88477 8.38086 6.5625 8 6.5625H7.0625C6.65234 6.5625 6.35938 6.88477 6.35938 7.26562C6.35938 7.67578 6.65234 7.96875 7.0625 7.96875H7.29688V9.8438H6.82812C6.41797 9.8438 6.125 10.166 6.125 10.5469C6.125 10.957 6.41797 11.25 6.82812 11.25H9.17188C9.55273 11.25 9.875 10.957 9.875 10.5469C9.875 10.166 9.55273 9.8438 9.17188 9.8438ZM8 5.625C8.49805 5.625 8.9375 5.21484 8.9375 4.6875C8.9375 4.18945 8.49805 3.75 8 3.75C7.47266 3.75 7.0625 4.18945 7.0625 4.6875C7.0625 5.21484 7.47266 5.625 8 5.625Z"
                                          fill="#2D2D2D"
                                        />
                                      </svg>
                                    </span>
                                  </span>
                                </OverlayTrigger>
                              </label>
                              <Field
                                id="workshopName"
                                name="workshopName"
                                type="text"
                                className={`form-control ${errors.workshopName && touched.workshopName ? "is-invalid" : ""
                                  }`}
                                disabled={sessionOnlyUpdate}
                                // className={`form-control ${errors.workshopName && touched.workshopName
                                //     ? "is-invalid"
                                //     : ""
                                //   }`}
                                // value={inputWorkshopValue || formikRef.current?.values?.workshopName}
                                placeholder={t("enterWorkshopName")}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              // onChange={(e) => {
                              //   if (e.target.value === "") {
                              //     setWorkshopValidation(
                              //       "Workshop Name is required"
                              //     );
                              //   } else {
                              //     setWorkshopValidation("");
                              //   }
                              //   setWorkshopInputValue(e.target.value);
                              // }}
                              // onKeyPress={(e) => {
                              //   const regex = /^[A-Za-z\s]*$/; // Allow only alphabets and spaces
                              //   if (!regex.test(e.key)) {
                              //     e.preventDefault(); // Prevent invalid input
                              //   }
                              // }}
                              />
                              <ErrorMessage
                                name="workshopName"
                                component="div"
                                className="invalid-feedback"
                              />
                              {/* {workshopValidation ? (
                                <span className="trainer_val text-danger">
                                  {workshopValidation}
                                </span>
                              ) : (
                                ""
                              )} */}
                            </Col>

                            <Col md={12}>
                              <form.Group
                                className="frm-box"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault(); // Prevent Enter key from submitting the form
                                  }
                                }}
                              >
                                <label
                                  id="trainerName"
                                  htmlFor="trainerName"
                                  className="form-label"
                                >
                                  {t("trainer(s)Name")}
                                  <sup className="text-danger">*</sup>
                                  <OverlayTrigger
                                    overlay={
                                      <Tooltip id="tooltip-disabled">
                                        {t("InfoTextWillComehere")}
                                      </Tooltip>
                                    }
                                  >
                                    <span className="d-inline-block">
                                      <span className="info">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="15"
                                          viewBox="0 0 16 15"
                                          fill="none"
                                        >
                                          <path
                                            d="M8 0C3.83984 0 0.5 3.36914 0.5 7.5C0.5 11.6602 3.83984 15 8 15C12.1309 15 15.5 11.6602 15.5 7.5C15.5 3.36914 12.1309 0 8 0ZM8 13.5938C4.63086 13.5938 1.90625 10.8691 1.90625 7.5C1.90625 4.16016 4.63086 1.40625 8 1.40625C11.3398 1.40625 14.0938 4.16016 14.0938 7.5C14.0938 10.8691 11.3398 13.5938 8 13.5938ZM9.17188 9.8438H8.70312V7.26562C8.70312 6.88477 8.38086 6.5625 8 6.5625H7.0625C6.65234 6.5625 6.35938 6.88477 6.35938 7.26562C6.35938 7.67578 6.65234 7.96875 7.0625 7.96875H7.29688V9.8438H6.82812C6.41797 9.8438 6.125 10.166 6.125 10.5469C6.125 10.957 6.41797 11.25 6.82812 11.25H9.17188C9.55273 11.25 9.875 10.957 9.875 10.5469C9.875 10.166 9.55273 9.8438 9.17188 9.8438ZM8 5.625C8.49805 5.625 8.9375 5.21484 8.9375 4.6875C8.9375 4.18945 8.49805 3.75 8 3.75C7.47266 3.75 7.0625 4.18945 7.0625 4.6875C7.0625 5.21484 7.47266 5.625 8 5.625Z"
                                            fill="#2D2D2D"
                                          />
                                        </svg>
                                      </span>
                                    </span>
                                  </OverlayTrigger>
                                </label>
                                <div className="frmdorp position-relative">
                                  {/* <form.Control
                                    type="text"
                                    name="trainerIds"
                                    placeholder="Enter trainer name"
                                    value={inputValue}
                                    onChange={handleInputChange}
                                    className={
                                      trainerValidation || (errors.trainerIds && touched.trainerIds) ? "is-invalid" : ""
                                    }
                                  /> */}
                                  <Field
                                    name="trainerName"
                                    type="text"
                                    className={`form-control ${errors.trainerIds ? "is-invalid" : ""
                                      }`}
                                    placeholder={t("enterTrainerName")}
                                    value={inputValue}
                                    onChange={(e) => handleInputChange(e, values.trainerIds)}
                                  />
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    //onClick={handleSearchClick}
                                    className="cursor-pointer"
                                  >
                                    <path
                                      d="M19.6973 18.3984L14.4629 13.1641C15.5957 11.7969 16.2207 10.0391 16.2207 8.125C16.2207 3.67188 12.5489 0 8.09571 0C3.60352 0 0.00976562 3.67188 0.00976562 8.125C0.00976562 12.6172 3.64258 16.25 8.09571 16.25C9.97071 16.25 11.7286 15.625 13.1348 14.4922L18.3692 19.7266C18.5645 19.9219 18.7989 20 19.0723 20C19.3067 20 19.541 19.9219 19.6973 19.7266C20.0879 19.375 20.0879 18.7891 19.6973 18.3984ZM1.88477 8.125C1.88477 4.6875 4.65821 1.875 8.13477 1.875C11.5723 1.875 14.3848 4.6875 14.3848 8.125C14.3848 11.6016 11.5723 14.375 8.13477 14.375C4.65821 14.375 1.88477 11.6016 1.88477 8.125Z"
                                      fill="black"
                                    />
                                  </svg>


                                  {showSuggestions &&
                                    inputValue &&
                                    filteredSuggestions.length > 0 ? (
                                    <ul className="dropdown-menu d-block p-0 m-0">
                                      {filteredSuggestions.map((trainer) => (
                                        <div
                                          key={trainer.id}
                                          className="suggestion-item cursor-pointer"
                                          onClick={() => {
                                            // handleSuggestionClick(trainer);
                                            // if values.trainerIds is empty then push id or else check if id present if not then push
                                            if (_.isEmpty(values.trainerIds)) {
                                              setFieldValue("trainerIds", [trainer.id])
                                            } else {
                                              if (!_.includes(values.trainerIds, trainer.id)) {
                                                setFieldValue("trainerIds", [...values.trainerIds, trainer.id])
                                              }
                                            }
                                            setInputValue("");
                                            setShowSuggestions(false);
                                          }}
                                        >
                                          {trainer.display_name}
                                        </div>
                                      ))}
                                    </ul>
                                  ) :
                                    showSuggestions &&
                                    inputValue &&
                                    filteredSuggestions.length == 0 && (
                                      <ul className="dropdown-menu d-block p-0 m-0">
                                        <div
                                          className="suggestion-item cursor-pointer"
                                        >
                                          No trainer(s) as per input.
                                        </div>
                                      </ul>
                                    )
                                  }
                                </div>
                                {(trainerValidation && isFormDirty) ? (
                                  <span className="trainer_val text-danger">
                                    {trainerValidation}
                                  </span>
                                ) : (
                                  ""
                                )}
                                <ErrorMessage
                                  name="trainerIds"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </form.Group>
                              <div className="selected-skills mt-2">
                                {/* Using trainersList only display trainer from values.trainerIds */}
                                {
                                  !_.isEmpty(trainersList) &&
                                  !_.isEmpty(values.trainerIds) && values.trainerIds[0] &&
                                  values.trainerIds.map((id) => {
                                    const trainer = trainersList.find(trainer => trainer.id === id)
                                    
                                    return (
                                      <span key={id} className="skill-tag">
                                        {/* {JSON.stringify(trainer)} */}
                                        {trainer?.profile ? (
                                          <img src={trainer?.profile} alt="" />
                                        ) : (
                                          <img src="/images/profile_avatar.png" alt="" />
                                        )}
                                        {trainer?.display_name} {/* Render the name */}
                                        <button
                                          type="button"
                                          className="remove-skill-btn"
                                          onClick={() => {
                                            // Remove from id from values.trainerIds
                                            if (!_.isEmpty(values.trainerIds)) {
                                              setFieldValue("trainerIds", _.filter(values.trainerIds, id => id !== trainer.id))
                                            }
                                          }}
                                        >&nbsp;✕&nbsp;</button>
                                      </span>
                                    )
                                  })
                                }
                              </div>
                              <div className="trainer-list-link mt-2">
                                <u
                                  className="cursor-pointer "
                                  onClick={() => setShowModal(true)}
                                >{t("viewTrainer'SList")}</u>
                              </div>
                            </Col>

                            {!sessionOnlyUpdate &&
                              <Col md={12}>
                                <label htmlFor="session" className="form-label">
                                  {t("session")}<sup className="text-danger">*</sup>
                                </label>
                                <div className="d-flex gap-3">
                                  <div className="form-check d-flex align-items-center gap-2">
                                    <Field
                                      className="form-check-input wb"
                                      type="radio"
                                      name="sessionType"
                                      id="flexRadioDefault1"
                                      value="single"
                                    // checked={
                                    //   selectedOption === "flexRadioDefault1"
                                    // }
                                    // onChange={(event) => {
                                    //   handleChange(event); // Call your custom handler
                                    //   if (formikRef.current) {
                                    //     handleRecurringSessionClick(
                                    //       "sessionType",
                                    //       "single"
                                    //     );
                                    //   }
                                    // }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexRadioDefault1"
                                    >
                                      {t("singleSession")}
                                    </label>
                                  </div>

                                  {/* Recurring Session Radio Button */}
                                  <div className="form-check d-flex align-items-center gap-2">
                                    <Field
                                      className="form-check-input wb"
                                      type="radio"
                                      name="sessionType"
                                      id="flexRadioDefault2"
                                      value="recurring"
                                      // onChange={(event) => {
                                      //   handleChange(event); // Call your custom handler
                                      //   if (formikRef.current) {
                                      //     handleRecurringSessionClick(
                                      //       "sessionType",
                                      //       "recurring"
                                      //     );
                                      //   }
                                      // }}
                                      // checked={
                                      //   selectedOption === "flexRadioDefault2"
                                      // }
                                      onChange={(e) => {
                                        handleChange(e);
                                        if (formikRef.current) {
                                          setFieldValue("sessionArray", [values.sessionArray[0]]);
                                        }
                                      }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexRadioDefault2"
                                    >
                                      {t("recurringSession")}
                                    </label>
                                  </div>
                                </div>
                              </Col>}
                            <Col md={12}>
                              {!sessionOnlyUpdate &&
                                <>
                                  <h5 className="card-title mb-3">
                                    {values.sessionType}  {t("session")}
                                  </h5>
                                  <div className="check-box-wrap">
                                    <div class="form-check d-flex align-items-center gap-2">
                                      <input
                                        className="form-check-input wb"
                                        type="checkbox"
                                        value=""
                                        id="flexCheckDisabled"
                                        checked
                                        disabled
                                      />
                                      <label
                                        className="form-check-label"
                                        for="flexCheckDisabled"
                                      >
                                        {t("kindlyNoteThatAllTheSelectedParticipants")}
                                      </label>
                                    </div>
                                  </div>
                                </>}
                              {
                                sessionOnlyUpdate && hasSeries &&
                                <div className="check-box-wrap">
                                  <div class="form-check d-flex align-items-center gap-2">
                                    {/* <input
                                        className="form-check-input wb"
                                        type="checkbox"
                                        value=""
                                        id="flexCheckDisabled"
                                        checked
                                        disabled
                                      /> */}
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDisabled"
                                    >
                                      {t(" you'reEditingAnOccurence")} <span
                                        className="text-link text-decoration-underline cursor-pointer"
                                        onClick={() => {
                                          setSessionOnlyUpdate(false);
                                          setSessionId('')
                                        }}
                                      >{t("editWorkshop")}</span>
                                    </label>
                                  </div>
                                </div>
                              }
                              {
                                !sessionOnlyUpdate && hasSeries &&
                                <div className="check-box-wrap">
                                  <div class="form-check d-flex align-items-center gap-2">
                                    <input
                                      className="form-check-input wb"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDisabled"
                                      checked
                                      disabled
                                    />
                                    <label
                                      className="form-check-label"
                                      for="flexCheckDisabled"
                                    >
                                      {t("you'reEditingAWorkshop")}
                                    </label>
                                  </div>
                                </div>
                              }
                              {/* <p className="infopag mt-3">
                                Sessions cannot be created within 2 hours of the
                                current time.
                              </p> */}
                              <FieldArray name="sessionArray">
                                {({ remove, push }) => (
                                  <div id="sessionArray">
                                    {
                                      values.sessionArray.length > 0 &&
                                      values.sessionArray.map((session, index) => {
                                        return (
                                          renderSessionCard(session, index, values, remove)
                                        )
                                      })
                                    }
                                    {values.sessionType === "single" && !sessionOnlyUpdate &&
                                      <>
                                        <button
                                          type="button"
                                          className="btn-primary active-page mt-3"
                                          onClick={async () => {
                                            setErrorMsgSession('')
                                            const isSessionDataValid = await sessionObjectValidationSchema.isValid(values.sessionArray[values.sessionArray.length - 1])
                                            if (isSessionDataValid) {
                                              push({
                                                sessionId: "", //randomGenerator(5),
                                                segmentId: "",
                                                sessionName: "",
                                                sessionStartDate: "",
                                                sessionEndDate: "",
                                                sessionStartTime: "",
                                                sessionEndTime: "",
                                                modeOfAttendance: "online",
                                                sessionAddress: "",
                                                sessionURL: "",
                                                sessionStartDateTime: "",
                                                sessionEndDateTime: "",
                                                isKickoffSession: false
                                              })
                                            } else {
                                              setErrorMsgSession("Please enter valid session data, before adding more sessions.")
                                            }
                                          }}
                                        >

                                          {t("+addDay")}
                                        </button>
                                        <div className="invalid-feedback">{errorMsgSession}</div>
                                      </>
                                    }
                                  </div>
                                )}
                              </FieldArray>
                              {/* ))} */}

                              {/* {selectedOption === "flexRadioDefault1" && (
                                <button
                                  type="button"
                                  className="btn-primary active-page mt-3"
                                  onClick={addCard}
                                >
                                  + Add Day
                                </button>
                              )} */}
                            </Col>
                            {/* Timezone */}
                            {/* <div>
                              <label
                                id="timezone"
                                htmlFor="timezone" className="form-label">
                                {t("timezone")}
                                <sup className="text-danger">*</sup>
                              </label>
                              <Field
                                as="select"
                                name="timezone"
                                className={`form-control ${errors.timezone && touched.timezone
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                value={formikRef.current?.values?.timezone}
                              >
                                <option value="">{t("selectATimezone")}</option>
                                {timezoneList.map((tz) => (
                                  <option key={tz.id} value={`${tz.offset}#${tz.abbreviations}`}>
                                    {`${tz.timezone} (${tz.offset})`}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="timezone"
                                component="div"
                                className="trainer_val text-danger"
                              />
                            </div> */}
                            {/* Language */}
                            {/* {!sessionOnlyUpdate &&
                              <div>
                                <label
                                  id="language"
                                  htmlFor="language"
                                  className="form-label"
                                >
                                  {t("language")}
                                  <sup className="text-danger">*</sup>
                                </label>
                                <Field
                                  as="select"
                                  name="language"
                                  className={`form-control ${errors.language && touched.language
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                  value={values?.language}
                                >
                                  <option value="">Select a language</option>
                                  {languageOptions.map((lan) => (
                                    <option key={lan.id} value={lan.id}>
                                      {lan.label}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="language"
                                  component="div"
                                  className="trainer_val text-danger"
                                />
                              </div>} */}

                            <Col md={12}>
                              <form.Group
                                className="frm-box"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault(); // Prevent Enter key from submitting the form
                                  }
                                }}
                              >
                                <label
                                  id="participant"
                                  for="Add End user"
                                  className="form-label"
                                >
                                  {t("addParticipant(s)")}
                                  <sup className="text-danger">*</sup>
                                </label>
                                <div className="frmdorp position-relative">
                                  <Field
                                    name="participantName"
                                    type="text"
                                    className={`form-control ${errors.participantIds &&
                                      touched.participantIds
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    placeholder={t("enterName")}
                                    value={inputValueParticipant}
                                    onChange={(e) => handleInputChangeParticipant(e, values.participantIds)}
                                  />
                                  <span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      //onClick={handleSearchClick}
                                      className="cursor-pointer"
                                    >
                                      <path
                                        d="M19.6973 18.3984L14.4629 13.1641C15.5957 11.7969 16.2207 10.0391 16.2207 8.125C16.2207 3.67188 12.5489 0 8.09571 0C3.60352 0 0.00976562 3.67188 0.00976562 8.125C0.00976562 12.6172 3.64258 16.25 8.09571 16.25C9.97071 16.25 11.7286 15.625 13.1348 14.4922L18.3692 19.7266C18.5645 19.9219 18.7989 20 19.0723 20C19.3067 20 19.541 19.9219 19.6973 19.7266C20.0879 19.375 20.0879 18.7891 19.6973 18.3984ZM1.88477 8.125C1.88477 4.6875 4.65821 1.875 8.13477 1.875C11.5723 1.875 14.3848 4.6875 14.3848 8.125C14.3848 11.6016 11.5723 14.375 8.13477 14.375C4.65821 14.375 1.88477 11.6016 1.88477 8.125Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </span>

                                  {showSuggestionsParticipants &&
                                    inputValueParticipant &&
                                    filteredSuggestionsParticipant.length > 0 ? (
                                    <ul className="dropdown-menu d-block mt-1">
                                      {filteredSuggestionsParticipant.map(
                                        (member) => (
                                          <div
                                            key={member.id}
                                            className="suggestion-item cursor-pointer"
                                            onClick={() => {
                                              // handleSuggestionClickParticipant(
                                              //   member
                                              // )
                                              if (_.isEmpty(values.participantIds)) {
                                                setFieldValue("participantIds", [member.id])
                                              } else {
                                                if (!_.includes(values.participantIds, member.id)) {
                                                  setFieldValue("participantIds", [...values.participantIds, member.id])
                                                }
                                              }
                                              setInputValueParticipant("")
                                              setShowSuggestionsParticipants(false);
                                            }}
                                          >
                                            {member.first_name}{" "}
                                            {member.last_name}
                                          </div>
                                        )
                                      )}
                                    </ul>
                                  ) : inputValueParticipant &&
                                  showSuggestionsParticipants &&
                                  filteredSuggestionsParticipant.length == 0 && (
                                    <ul className="dropdown-menu d-block mt-1">
                                      <div className="m-3">
                                        No participant(s) as per input.
                                      </div>
                                    </ul>
                                  )}
                                </div>
                                <ErrorMessage
                                  name="participantIds"
                                  component="div"
                                  className="invalid-feedback"
                                />
                                {(memberValidation && isFormDirty) ? (
                                  <span className="trainer_val text-danger">
                                    {memberValidation}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </form.Group>

                              <div
                                className="trainer-list-link cursor-pointer mt-2"
                                onClick={() => setMembersModal(true)}
                              >
                                <u>{t("viewTeamMember'sList")}</u>
                              </div>
                              <div className="selected-skills mt-2">
                                
                                {
                                  !_.isEmpty(membersList) &&
                                  !_.isEmpty(values.participantIds) && values.participantIds.map((id) => {
                                    const member = membersList.find(member => member.id == id)
                                    return (
                                      <span key={id} className="skill-tag">
                                        {member?.profile_image ? (
                                          <img src={member?.profile_image} alt="" />
                                        ) : (
                                          <img src="/images/profile_avatar.png" alt="" />
                                        )}
                                        {member?.first_name} {member?.middle_name} {member?.last_name}
                                        <button
                                          type="button"
                                          className="remove-skill-btn"
                                          onClick={() => {
                                            // Remove from id from values.participantIds
                                            if (!_.isEmpty(values.participantIds)) {
                                              setFieldValue("participantIds", _.filter(values.participantIds, id => id !== member.id))
                                            }
                                          }}
                                        >&nbsp;✕&nbsp;</button>
                                      </span>
                                    )
                                  })
                                }
                              </div>
                            </Col>
                            {false && !sessionOnlyUpdate &&
                              <div className="col-md-12">
                                <label
                                  id="status"
                                  htmlFor="Status" className="form-label">
                                  {t("Status")}<sup className="text-danger">*</sup>
                                </label>
                                <div className="d-flex gap-3">
                                  <div className="form-check d-flex align-items-center gap-2">
                                    <Field
                                      className="form-check-input wb"
                                      type="radio"
                                      name="status"
                                      id="statusflexRadioDefault1"
                                      value="active"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="statusflexRadioDefault1"
                                    >
                                      {t("Active")}
                                    </label>
                                  </div>
                                  <div className="form-check d-flex align-items-center gap-2">
                                    <Field
                                      className="form-check-input wb"
                                      type="radio"
                                      name="status"
                                      id="statusflexRadioDefault2"
                                      value="inactive"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="statusflexRadioDefault2"
                                    >
                                      {t("Inactive")}
                                    </label>
                                  </div>
                                </div>
                              </div>}
                            {
                              !sessionOnlyUpdate &&
                              <>
                                {/* Description Field */}
                                <div className="col-md-12">
                                  <label
                                    id="description"
                                    htmlFor="description"
                                    className="form-label"
                                  >
                                    {t("workshopActivities")}
                                    <sup className="text-danger">*</sup>
                                  </label>
                                  <div className="mb-3">
                                    <div
                                      className={`form-control ${errors.description && touched.description
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                    >
                                      <RichTextEditor
                                        name='description'
                                        value={formikRef?.current?.values?.description}
                                        form={formikRef?.current}
                                        editorData={workshopData?.description || ""}
                                      />
                                    </div>
                                    <ErrorMessage
                                      name="description"
                                      component="div"
                                      className="trainer_val text-danger"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="d-flex gap-2 flex-column">
                                    <label
                                      id="kickoffarea"
                                      htmlFor="Status"
                                      className="form-label m-0"
                                    >
                                      {t("kickOffSession")}
                                    </label>
                                    <div className="d-flex gap-3 align-items-center">
                                      <span>
                                        {t("doYouWantAKickoffSessionForThisWorkshop")}
                                      </span>
                                      <div class="form-check form-switch">
                                        <input
                                          class="form-check-input"
                                          type="checkbox"
                                          id="flexSwitchCheckChecked"
                                          onChange={(e) =>
                                            setIsChecked(e.target.checked)
                                          }
                                          checked={isChecked ? "1" : ""}
                                        />
                                        <label
                                          class="form-check-label"
                                          for="flexSwitchCheckChecked"
                                        >
                                          {t("Yes")}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  {isChecked && (
                                    <KickoffSessionCardForm
                                      timezoneList={timezoneList}
                                      languageList={languageList}
                                      isTimezoneListLoading={isTimezoneListLoading}
                                      isLanguageListLoading={isLanguageListLoading}
                                    />
                                  )}
                                </div>
                                {/* Workshop  Prerequisites */}
                                {renderWorkshopPrerequisites(values, touched, errors, setFieldValue)}

                                {/* Thumbnail */}
                                <Col md={12} className="mt-3">
                                  <label htmlFor="thumbnail" className="form-label">
                                    {t("thumbnail")} <sup className="text-danger">*</sup>
                                  </label>
                                  <div className="d-flex  gap-5">
                                    <div className="col-6-v">
                                      <label htmlFor="Default" className="form-label">
                                        {t("default")}
                                      </label>
                                      <div className="d-fault-img-box">
                                        <div class="thumbnail-bar">
                                          <img
                                            class="thumbnailimg"
                                            src="https://cdnstg.training.com/halifax/image/10543/2058509172-20241212.png"
                                            alt=""
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-6-v d-flex align-items-center">
                                      <div className="or">{t("oR")}</div>
                                    </div>
                                    <div className="col-6-v">
                                      <label htmlFor=" Custom" className="form-label">
                                        {t("custom")}
                                      </label>
                                      {thumbnail ? (
                                        <>
                                          <div className="d-fault-img-box">
                                            <div class="thumbnail-bar">
                                              <img
                                                class="thumbnailimg"
                                                src={thumbnail}
                                                alt=""
                                              />
                                            </div>
                                          </div>
                                          <div class="lh-1 d-block text-start info-msg mt-1">
                                            <a
                                              onClick={() => {
                                                if (!sessionOnlyUpdate) {
                                                  setFieldValue("thumbnail", "")
                                                  setThumbnail("")
                                                }
                                              }}
                                              id="removeImage"
                                              className="text-primary-link cursor-pointer"
                                            >
                                              {t("removeThumbnail")}
                                            </a>
                                          </div>
                                        </>
                                      ) : (
                                        <div
                                          id="ekvvcgd"
                                          class=""
                                          onClick={handleThumbnailUploadClick}
                                        >
                                          <div class="custom-thumbnail-sec text-center">
                                            <label style={{ display: "none" }}>
                                              {t("file")}
                                              <input
                                                type="file"
                                                name="peFile"
                                                accept="image/png,image/jpeg"
                                                id="exampleThumbnailCover"
                                                style={{ display: "none" }}
                                                onChange={handleThumbnailChange}
                                                disabled={sessionOnlyUpdate}
                                              />
                                            </label>
                                            <div
                                              class="thumbnail-card mb-1 pe-upload-area"
                                              id="peUploadfile"
                                              tabindex="0"
                                              aria-describedby="uploadErrorMsg"
                                              aria-label="Custom Thumbnail"
                                              role="button"
                                            >
                                              <div class="thumbnail-card-inner">
                                                <div class="thumbnail-bar">
                                                  <label
                                                    className={`lh-sm mt-2 fw-semibold btnhover ${sessionOnlyUpdate ? "cursor-not-allowed" : "cursor-pointer"}`}
                                                    for="file-uploadthmcsus"
                                                  >
                                                    {t("uploadImage")}
                                                  </label>

                                                  <small class="lh-1 mt-1 d-block">
                                                    {t("imageSize:")}
                                                  </small>

                                                  <small class="lh-1 mt-1 d-block">
                                                    300 X 300
                                                  </small>
                                                </div>
                                              </div>
                                            </div>

                                            <div class="lh-1 d-block text-start info-msg">
                                              {/* Drag an image here or <br /> */}
                                              {/* <a
                                                class="text-primary-link"
                                                id="peUploadfileText"
                                              >
                                                {" "}
                                                {t("uploadAFile")}
                                              </a> */}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                                <Col md={12} className="mt-3">
                                  <label htmlFor="banner" className="form-label">
                                    {t("banner")} <sup className="text-danger">*</sup>
                                  </label>
                                  <div className="d-flex  gap-5">
                                    <div className="col-6-v">
                                      <label
                                        htmlFor="Default"
                                        className="form-label font-sm"
                                      >
                                        {t("default")}
                                      </label>
                                      <div className="d-fault-img-box Bannerbox">
                                        <div class="thumbnail-bar">
                                          <img
                                            class="thumbnailimg"
                                            src="https://cdnstg.training.com/halifax/image/10543/2016513182-20241212.png"
                                            alt=""
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-6-v d-flex align-items-center">
                                      <div className="or">OR</div>
                                    </div>
                                    <div className="col-6-v">
                                      <label
                                        htmlFor=" Custom"
                                        className="form-label font-sm"
                                      >
                                        {t("custom")}
                                      </label>
                                      {banner ? (
                                        <>
                                          <div className="d-fault-img-box Bannerbox">
                                            <div class="thumbnail-bar">
                                              <img
                                                class="thumbnailimg"
                                                src={banner}
                                                alt=""
                                              />
                                            </div>
                                          </div>
                                          <div class="lh-1 d-block text-start info-msg mt-1">
                                            <a
                                              class="text-primary-link cursor-pointer"
                                              id="peUploadfileText"
                                              onClick={() => {
                                                if (!sessionOnlyUpdate) {
                                                  setBanner("")
                                                  setFieldValue("banner", "")
                                                }
                                              }}
                                            >
                                              {" "}
                                              {t("removeBanner")}
                                            </a>
                                          </div>
                                        </>
                                      ) : (
                                        <div id="ekvvcgd" class="">
                                          <div
                                            class="custom-thumbnail-sec text-center"
                                            onClick={handleBannerUploadClick}
                                          >
                                            <label style={{ display: "none" }}>
                                              {t("file")}
                                              <input
                                                type="file"
                                                name="peFile"
                                                accept="image/png,image/jpeg"
                                                id="exampleBannerCover"
                                                style={{ display: "none" }}
                                                onChange={handleBannerChange}
                                                disabled={sessionOnlyUpdate}
                                              />
                                            </label>
                                            <div
                                              className={`thumbnail-card mb-1 pe-upload-area Bannerdf ${sessionOnlyUpdate ? "cursor-not-allowed" : ""}`}
                                              id="peUploadfile"
                                              tabindex="0"
                                              aria-describedby="uploadErrorMsg"
                                              aria-label="Custom Thumbnail"
                                              role="button"
                                            >
                                              <div class="thumbnail-card-inner">
                                                <div class="thumbnail-bar">
                                                  <label
                                                    className={`lh-sm mt-2 fw-semibold btnhover ${sessionOnlyUpdate ? "cursor-not-allowed" : "cursor-pointer"}`}
                                                    for="file-uploadthm"
                                                  >
                                                    {t("uploadImage")}
                                                  </label>

                                                  <small class="lh-1 mt-1 d-block">
                                                    {t("imageSize:")}
                                                  </small>

                                                  <small class="lh-1 mt-1 d-block">
                                                    1920 X 390
                                                  </small>
                                                </div>
                                              </div>
                                            </div>

                                            <div class="lh-1 d-block text-start info-msg">
                                              {/* Drag an image here or <br /> */}
                                              {/* <a
                                                className={`text-primary-link ${sessionOnlyUpdate ? "cursor-not-allowed" : ""}`}
                                                id="peUploadfileText"
                                                href="#"
                                              >
                                                {" "}
                                                {t("uploadAFile")}
                                              </a> */}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                                <Col md={12} className="mt-3">
                                  <label
                                    htmlFor="workshopResource"
                                    className="form-label"
                                  >
                                    {t("workshopResource")}{" "}
                                  </label>
                                  <div className="d-flex  gap-5">
                                    <div
                                      className={`file-uploader ${sessionOnlyUpdate ? "cursor-not-allowed" : "cursor-pointer"}`}
                                      onClick={() =>
                                        !sessionOnlyUpdate && document.getElementById("file2").click()
                                      }
                                    >
                                      <div className="iocn">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="18"
                                          viewBox="0 0 24 18"
                                          fill="none"
                                        >
                                          <path
                                            d="M11.3691 6.05273C11.7031 5.71875 12.2598 5.71875 12.5938 6.05273L15.5625 9.02148C15.9336 9.39257 15.9336 9.94921 15.5625 10.2832C15.2285 10.6543 14.6719 10.6543 14.3379 10.2832L12.8906 8.83593V13.8086C12.8906 14.3281 12.4824 14.6992 12 14.6992C11.4805 14.6992 11.1094 14.3281 11.1094 13.8086V8.83593L9.625 10.2832C9.29102 10.6543 8.73438 10.6543 8.40039 10.2832C8.0293 9.94921 8.0293 9.39257 8.40039 9.02148L11.3691 6.05273ZM5.46875 17.3711C2.5 17.3711 0.125 14.9961 0.125 12.0274C0.125 9.72656 1.60938 7.72265 3.6875 7.01757V6.98047C3.6875 3.5664 6.4707 0.746094 9.92188 0.746094C11.7773 0.746094 13.4844 1.59961 14.6348 2.93554C15.1914 2.67578 15.7852 2.52734 16.4531 2.52734C18.9023 2.52734 20.9062 4.53125 20.9062 6.98047C20.9062 7.24023 20.8691 7.46289 20.832 7.72265C22.6133 8.50195 23.875 10.2832 23.875 12.3242C23.875 15.0332 21.7598 17.2227 19.125 17.3711H5.46875ZM9.92188 2.52734C7.43555 2.52734 5.46875 4.53125 5.46875 6.98047V8.27929L4.24414 8.6875C2.87109 9.16992 1.90625 10.5059 1.90625 12.0274C1.90625 13.9941 3.46484 15.5898 5.46875 15.5898H18.9023H19.0137C20.7207 15.5156 22.0938 14.0684 22.0938 12.3242C22.0938 10.9883 21.2773 9.83789 20.127 9.35547L18.8652 8.79882L19.0879 7.42578C19.0879 7.27734 19.125 7.1289 19.125 6.98047C19.125 5.5332 17.9004 4.30859 16.4531 4.30859C16.0449 4.30859 15.6738 4.41992 15.3398 4.56836L14.1523 5.08789L13.2617 4.08593C12.4453 3.1582 11.2578 2.52734 9.88477 2.52734H9.92188Z"
                                            fill="#2D2D2D"
                                          />
                                        </svg>
                                      </div>
                                      <div className="textf">FILE FORMAT(S)</div>
                                      <div className="filemsg">
                                        {t("dropUpTo20MBFilesHereToUploadOr")}
                                      </div>
                                      <label
                                        for="file-upload1"
                                        className={`upload-link chossefiles ${sessionOnlyUpdate ? "cursor-not-allowed" : ""}`}
                                      >
                                        {t("chooseFiles")}
                                      </label>
                                      <input
                                        type="file"
                                        id="file2"
                                        class="upload-input"
                                        accept=".pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx"
                                        onChange={handleResourceFileChange}
                                        disabled={sessionOnlyUpdate}
                                      />

                                      <div className="w-100">
                                        {resource?.map((item) => {
                                          return (
                                            <ul className="listinguploadee  mt-4">
                                              <li>
                                                <span className="lef-infopx1">
                                                  <span className="iconxload">
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="18"
                                                      height="23"
                                                      viewBox="0 0 18 23"
                                                      fill="none"
                                                    >
                                                      <path
                                                        d="M16.4336 4.09765L13.2109 0.875004C12.6953 0.359374 12.0078 0.0585938 11.2773 0.0585938H3.5C1.95312 0.0585938 0.75 1.30468 0.75 2.80859V19.3086C0.75 20.8555 1.95312 22.0586 3.5 22.0586H14.5C16.0039 22.0586 17.25 20.8555 17.25 19.3086V6.03125C17.25 5.30078 16.9492 4.61328 16.4336 4.09765ZM15.1875 19.3086C15.1875 19.6953 14.8438 19.9961 14.5 19.9961H3.5C3.11328 19.9961 2.8125 19.6953 2.8125 19.3086V2.85156C2.8125 2.46484 3.11328 2.16406 3.5 2.16406H10.375V5.55859C10.375 6.33203 10.9766 6.93359 11.75 6.93359H15.1445V19.3086H15.1875ZM9.98828 12.6055C9.77344 12.6055 9.60156 12.7344 9.47266 12.9063L7.79688 15.4414L7.28125 14.7109C7.15234 14.5391 6.98047 14.4102 6.76562 14.4102C6.59375 14.4102 6.37891 14.5391 6.29297 14.7109L4.27344 17.7188C4.14453 17.8906 4.14453 18.1484 4.23047 18.3203C4.35938 18.5352 4.53125 18.6211 4.74609 18.6211H13.168C13.3828 18.6211 13.5977 18.5352 13.6836 18.3203C13.7695 18.1484 13.7695 17.8906 13.6406 17.7188L10.4609 12.9063C10.375 12.7344 10.2031 12.6055 9.98828 12.6055ZM6.25 12.4336C6.98047 12.4336 7.625 11.832 7.625 11.0586C7.625 10.3281 6.98047 9.68359 6.25 9.68359C5.47656 9.68359 4.875 10.3281 4.875 11.0586C4.875 11.832 5.47656 12.4336 6.25 12.4336Z"
                                                        fill="#2D2D2D"
                                                      />
                                                    </svg>
                                                  </span>
                                                  <span className="filename">
                                                    {item?.name}
                                                  </span>
                                                </span>
                                                <span className="rightds">
                                                  <span className="filtduploaddate">
                                                    {item?.dateModified &&
                                                      dateTimeStamp(
                                                        item?.dateModified
                                                      ) + " | "}
                                                    {item?.size > 0 && (
                                                      (item?.size /
                                                        (1024 * 1024)).toFixed(2) + 'MB')}
                                                  </span>
                                                  <span className="downloandicon d-flex gap-2">
                                                    <svg
                                                      className="cursor-pointer iconde"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="20"
                                                      height="23"
                                                      viewBox="0 0 20 23"
                                                      fill="none"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        downloadPDF(
                                                          item?.url,
                                                          item?.name
                                                        );
                                                      }}
                                                    >
                                                      <path
                                                        d="M15.5 22.0586H4.5C2.17969 22.0586 0.375 20.2539 0.375 17.9336V14.8398C0.375 14.2813 0.804688 13.8086 1.40625 13.8086C1.96484 13.8086 2.4375 14.2813 2.4375 14.8398V17.9336C2.4375 19.0938 3.33984 19.9961 4.5 19.9961H15.5C16.6172 19.9961 17.5625 19.0938 17.5625 17.9336V14.8398C17.5625 14.2813 17.9922 13.8086 18.5938 13.8086C19.1523 13.8086 19.625 14.2813 19.625 14.8398V17.9336C19.625 20.2109 17.7773 22.0586 15.5 22.0586ZM10.6875 14.9258L16.5312 9.42579C16.9609 9.03906 16.9609 8.39453 16.5742 7.96484C16.1875 7.53515 15.543 7.53515 15.1133 7.92187L11.0312 11.7891V1.08984C11.0312 0.531254 10.5586 0.0585938 10 0.0585938C9.39844 0.0585938 8.96875 0.531254 8.96875 1.08984V11.7891L4.84375 7.92187C4.41406 7.53515 3.76953 7.53515 3.38281 7.96484C3.21094 8.17968 3.125 8.4375 3.125 8.65234C3.125 8.95312 3.21094 9.21093 3.42578 9.42579L9.26953 14.9258C9.65625 15.3125 10.3008 15.3125 10.6875 14.9258Z"
                                                        fill="#2D2D2D"
                                                      />
                                                    </svg>
                                                    <svg
                                                      className={`${sessionOnlyUpdate ? "cursor-not-allowed" : "cursor-pointer"} iconde`}
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="20"
                                                      height="23"
                                                      viewBox="0 0 20 23"
                                                      fill="none"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        !sessionOnlyUpdate && deleteFileFromResourceList(
                                                          item?.id
                                                        )
                                                      }}
                                                    >
                                                      <path
                                                        d="M7.28571 17.2461C7.28571 17.6328 6.94643 17.9336 6.60714 17.9336C6.22545 17.9336 5.92857 17.6328 5.92857 17.2461V8.30859C5.92857 7.96484 6.22545 7.62109 6.60714 7.62109C6.94643 7.62109 7.28571 7.96484 7.28571 8.30859V17.2461ZM10.6786 17.2461C10.6786 17.6328 10.3393 17.9336 10 17.9336C9.6183 17.9336 9.32143 17.6328 9.32143 17.2461V8.30859C9.32143 7.96484 9.6183 7.62109 10 7.62109C10.3393 7.62109 10.6786 7.96484 10.6786 8.30859V17.2461ZM14.0714 17.2461C14.0714 17.6328 13.7321 17.9336 13.3929 17.9336C13.0112 17.9336 12.7143 17.6328 12.7143 17.2461V8.30859C12.7143 7.96484 13.0112 7.62109 13.3929 7.62109C13.7321 7.62109 14.0714 7.96484 14.0714 8.30859V17.2461ZM13.9442 1.13281L15.5134 3.49609H18.4822C19.0334 3.49609 19.5 3.96875 19.5 4.52734C19.5 5.1289 19.0334 5.55859 18.4822 5.55859H18.1429V18.6211C18.1429 20.5547 16.616 22.0586 14.75 22.0586H5.25C3.34152 22.0586 1.85714 20.5547 1.85714 18.6211V5.55859H1.51786C0.924108 5.55859 0.5 5.1289 0.5 4.52734C0.5 3.96875 0.924108 3.49609 1.51786 3.49609H4.44419L6.0134 1.13281C6.4375 0.488284 7.20089 0.0585938 8.0067 0.0585938H11.9509C12.7567 0.0585938 13.5201 0.488284 13.9442 1.13281ZM6.90402 3.49609H13.0536L12.2477 2.29297C12.2054 2.20703 12.0782 2.12109 11.9509 2.12109H8.0067C7.87946 2.12109 7.75224 2.20703 7.70982 2.29297L6.90402 3.49609ZM3.89286 18.6211C3.89286 19.3945 4.4866 19.9961 5.25 19.9961H14.75C15.471 19.9961 16.1071 19.3945 16.1071 18.6211V5.55859H3.89286V18.6211Z"
                                                        fill="#2D2D2D"
                                                      />
                                                    </svg>
                                                  </span>
                                                </span>
                                              </li>
                                            </ul>
                                          );
                                        })}
                                        {isResourceLoading && (
                                          <ul className="listinguploadee mt-4 ">
                                            <ShimmerScreen
                                              case="rect"
                                              height="0.3125rem"
                                              width="100%"
                                            />
                                          </ul>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              </>
                            }
                            <div className="col-md-12 mt-5">
                              <div className="d-flex justify-content-end gap-3 btn-footer">
                                <button
                                  type="button"
                                  className="btn-primary"
                                  onClick={() => {
                                    if (dirty) {
                                      const confirmed = window.confirm("You have unsaved changes. Are you sure you want to leave?")
                                      if (confirmed) {
                                        navigate(-1)
                                      }
                                    } else {
                                      navigate(-1)
                                    }
                                  }}
                                >
                                  {t("cancel")}
                                </button>
                                {saveBtn && <button
                                  type="button"
                                  className="btn-primary active-page"
                                  onClick={() => {
                                    console.log(values)
                                    console.log(errors)
                                    console.log(touched)
                                    // TODO: UNCOMMENT THE BELOW WHEN PUBLISH BUTTON IS ENABLED
                                    // setFieldValue("isDraft", !_.isEmpty(workshopData) ? workshopData.is_draft : true)
                                    // setIsDraft(!_.isEmpty(workshopData) ? workshopData.is_draft : true)

                                    // TODO: COMMENT THE BELOW WHEN PUBLISH BUTTON IS ENABLED
                                    setFieldValue("isDraft", true)
                                    setIsDraft(false)


                                    let isFormValid = isValid && (Object.keys(touched).length > 0 || !_.isEmpty(workshopData))
                                    console.log("isFormValid", isFormValid)
                                    if (isFormValid) {
                                      handlePayload(values)
                                    } else {
                                      // alert(JSON.stringify(errors))
                                      console.log(values)
                                      console.log(errors)
                                      handleValidationScrolling(values, setFieldTouched)
                                    }
                                  }}
                                >
                                  {" "}
                                  {t("save")}
                                </button>}
                                {/* {!sessionOnlyUpdate && <button
                                  type="button"
                                  className="btn-primary active-page"
                                  onClick={() => {
                                    // setFieldValue("isDraft", !_.isEmpty(workshopData) ? true : false)
                                    if (!_.isEmpty(workshopData)) {
                                      setFieldValue("isDraft", !workshopData.is_draft)
                                    } else {
                                      setFieldValue("isDraft", true)
                                    }
                                    let isFormValid = isValid && (Object.keys(touched).length > 0 || !_.isEmpty(workshopData))
                                    console.log("isFormValid", isFormValid)
                                    if (isFormValid) {
                                      handlePayload(values)
                                    } else {
                                      // alert(JSON.stringify(errors))
                                      console.log(errors)
                                      handleValidationScrolling(values, setFieldTouched)
                                    }
                                  }}
                                >
                                  {" "}
                                  {btnName == 'publish' ? t('Publish') : t('unPublish')}
                                </button>} */}
                              </div>
                            </div>
                          </div>
                        </FormikForm>
                      </div>
                      <div className="col-xl-4 col-12">
                        <GroupPreviewWorkshop
                          banner={banner}
                          thumbnail={thumbnail}
                          participantChips={participantChips}
                          chips={chips}
                          currentLanguage={currentLanguage}
                          sessionURL={sessionURL}
                          status={status}
                          workshopName={inputWorkshopValue}
                          sessionDate={sessionDate}
                          prerequisites={prerequisites}
                          resource={resource}
                          sessionTime={sessionTime}
                          description={description}
                          formikRef={formikRef}
                          trainersList={trainersList}
                          membersList={membersList}
                          languageOptions={languageList}
                          timezoneOptions={timezoneList}
                        />
                      </div>
                    </div>
                  );
                }}
              </Formik>
            </div>
            {/* {false && 
            <div className="col-xl-4 col-12">
              <GroupPreviewWorkshop
                banner={banner}
                thumbnail={thumbnail}
                participantChips={participantChips}
                chips={chips}
                currentLanguage={currentLanguage}
                sessionURL={sessionURL}
                status={status}
                workshopName={inputWorkshopValue}
                sessionDate={sessionDate}
                prerequisites={prerequisites}
                resource={resource}
                sessionTime={sessionTime}
                description={description}
                formikRef={formikRef}
                trainersList={trainersList}
              />
            </div>} */}
          </div>
        </div>
      </section>
      {/* View Trainers Popup */}
      <GroupWorksopTrainerList
        show={showModal}
        onClose={() => setShowModal(false)}
        setShowModal={setShowModal}
        trainersList={trainersList}
        selectedTrainerId={selectedTrainerId}
        setSelectedTrainerId={setSelectedTrainerId}
        chips={chips}
        setChips={setChips}
        setTrainersList={setTrainersList}
        trainerIds={formikRef.current?.values?.trainerIds}
      />
      {/* View Members Popup */}
      <ViewMembersList
        membersModal={membersModal}
        setMembersModal={setMembersModal}
        membersList={membersList}
        setMembersList={setMembersList}
        selectedParticipantId={selectedParticipantId}
        setSelectedParticipantId={setSelectedParticipantId}
        participantChips={participantChips}
        setParticipantChips={setParticipantChips}
        participantIds={formikRef.current?.values?.participantIds}
      />
      <SimplePopup
        confirmModal={showLimitPopup}
        setConfirmModal={setShowLimitPopup}
        showModalMsg={error}
        isRightIcon={false}
      />
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        isConfirm={true}
        isConfirmwithNo={true}
        confirmId={""}
        confirmAction={() => navigate("/learn/group-workshops")}
        isRightIcon={true}
      />
    </>
  )
}

export default GroupWorkshopForm;